import { emptySplitApiV2 as api } from "./emptyApiV2";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProvidersAdmin: build.query<
      GetProvidersAdminApiResponse,
      GetProvidersAdminApiArg
    >({
      query: () => ({ url: `/v2/admin/expectation-providers` }),
    }),
    createProviderAdmin: build.mutation<
      CreateProviderAdminApiResponse,
      CreateProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers`,
        method: "POST",
        body: queryArg.expectationProviderDto,
      }),
    }),
    deleteProviderAdmin: build.mutation<
      DeleteProviderAdminApiResponse,
      DeleteProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
        method: "DELETE",
      }),
    }),
    getProviderAdmin: build.query<
      GetProviderAdminApiResponse,
      GetProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
      }),
    }),
    updateProviderAdmin: build.mutation<
      UpdateProviderAdminApiResponse,
      UpdateProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
        method: "PUT",
        body: queryArg.expectationProviderDto,
      }),
    }),
    getExpectationsAdmin: build.query<
      GetExpectationsAdminApiResponse,
      GetExpectationsAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations`,
        params: {
          providerCode: queryArg.providerCode,
        },
      }),
    }),
    createExpectationAdmin: build.mutation<
      CreateExpectationAdminApiResponse,
      CreateExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations`,
        method: "POST",
        body: queryArg.expectationAdminDto,
      }),
    }),
    deleteExpectationAdmin: build.mutation<
      DeleteExpectationAdminApiResponse,
      DeleteExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
        method: "DELETE",
      }),
    }),
    getExpectationAdmin: build.query<
      GetExpectationAdminApiResponse,
      GetExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
      }),
    }),
    updateExpectationAdmin: build.mutation<
      UpdateExpectationAdminApiResponse,
      UpdateExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
        method: "PUT",
        body: queryArg.expectationAdminDto,
      }),
    }),
    deleteBranch: build.mutation<DeleteBranchApiResponse, DeleteBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}`,
        method: "DELETE",
      }),
    }),
    getBranch: build.query<GetBranchApiResponse, GetBranchApiArg>({
      query: (queryArg) => ({ url: `/v2/branch/${queryArg.branchId}` }),
    }),
    updateBranch: build.mutation<UpdateBranchApiResponse, UpdateBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}`,
        method: "PUT",
        body: queryArg.branchDto,
      }),
    }),
    activateBranch: build.mutation<
      ActivateBranchApiResponse,
      ActivateBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/activate`,
        method: "POST",
      }),
    }),
    archiveBranch: build.mutation<
      ArchiveBranchApiResponse,
      ArchiveBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/archivate`,
        method: "POST",
      }),
    }),
    getBranchChanges: build.query<
      GetBranchChangesApiResponse,
      GetBranchChangesApiArg
    >({
      query: (queryArg) => ({ url: `/v2/branch/${queryArg.branchId}/changes` }),
    }),
    cherryPick: build.mutation<CherryPickApiResponse, CherryPickApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/cherry-pick`,
        method: "POST",
        body: queryArg.branchCherryPickRequestDto,
      }),
    }),
    previewCherryPick: build.mutation<
      PreviewCherryPickApiResponse,
      PreviewCherryPickApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/cherry-pick/preview`,
        method: "POST",
        body: queryArg.branchCherryPickRequestDto,
      }),
    }),
    updateDeploymentPackage: build.mutation<
      UpdateDeploymentPackageApiResponse,
      UpdateDeploymentPackageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/deployment-package`,
        method: "POST",
      }),
    }),
    getDataForDiagram: build.query<
      GetDataForDiagramApiResponse,
      GetDataForDiagramApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram`,
        params: {
          tableIds: queryArg.tableIds,
        },
      }),
    }),
    getDiagramById: build.query<
      GetDiagramByIdApiResponse,
      GetDiagramByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateDiagram: build.mutation<
      UpdateDiagramApiResponse,
      UpdateDiagramApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.newDiagram,
      }),
    }),
    getDiagramData: build.query<
      GetDiagramDataApiResponse,
      GetDiagramDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/data`,
      }),
    }),
    updateDiagramData: build.mutation<
      UpdateDiagramDataApiResponse,
      UpdateDiagramDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/data`,
        method: "PUT",
        body: queryArg.diagram,
      }),
    }),
    getDiagramOverview: build.query<
      GetDiagramOverviewApiResponse,
      GetDiagramOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/overview`,
      }),
    }),
    updateDiagramOverview: build.mutation<
      UpdateDiagramOverviewApiResponse,
      UpdateDiagramOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.diagramOverview,
      }),
    }),
    getDiagramSvg: build.query<GetDiagramSvgApiResponse, GetDiagramSvgApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/svg`,
      }),
    }),
    updateDiagramSvg: build.mutation<
      UpdateDiagramSvgApiResponse,
      UpdateDiagramSvgApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/diagram/${queryArg.structureId}/svg`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getStructureDetailFolder: build.query<
      GetStructureDetailFolderApiResponse,
      GetStructureDetailFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateFolderFolder: build.mutation<
      UpdateFolderFolderApiResponse,
      UpdateFolderFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.folder,
      }),
    }),
    getOdcsFolder: build.query<GetOdcsFolderApiResponse, GetOdcsFolderApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}/odcs`,
      }),
    }),
    updateOdcsFolder: build.mutation<
      UpdateOdcsFolderApiResponse,
      UpdateOdcsFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}/odcs`,
        method: "PUT",
        body: queryArg.basicData,
      }),
    }),
    setOdcsStatusFolder: build.mutation<
      SetOdcsStatusFolderApiResponse,
      SetOdcsStatusFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}/odcs/${queryArg.newStatus}`,
        method: "PUT",
      }),
    }),
    getFolderOverviewFolder: build.query<
      GetFolderOverviewFolderApiResponse,
      GetFolderOverviewFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}/overview`,
      }),
    }),
    updateFolderOverviewFolder: build.mutation<
      UpdateFolderOverviewFolderApiResponse,
      UpdateFolderOverviewFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/folder/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.folderOverview,
      }),
    }),
    unlockBranch: build.mutation<UnlockBranchApiResponse, UnlockBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/lock`,
        method: "DELETE",
      }),
    }),
    lockBranch: build.mutation<LockBranchApiResponse, LockBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/lock`,
        method: "POST",
      }),
    }),
    getStructureDetailMapping: build.query<
      GetStructureDetailMappingApiResponse,
      GetStructureDetailMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateMappingMapping: build.mutation<
      UpdateMappingMappingApiResponse,
      UpdateMappingMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.mapping,
      }),
    }),
    getMappingColumnsMapping: build.query<
      GetMappingColumnsMappingApiResponse,
      GetMappingColumnsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/column`,
      }),
    }),
    addMappingColumnMapping: build.mutation<
      AddMappingColumnMappingApiResponse,
      AddMappingColumnMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.mappingColumn,
      }),
    }),
    updateMappingColumnsMapping: build.mutation<
      UpdateMappingColumnsMappingApiResponse,
      UpdateMappingColumnsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    updateMappingColumnMapping1: build.mutation<
      UpdateMappingColumnMapping1ApiResponse,
      UpdateMappingColumnMapping1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateMappingColumnMapping: build.mutation<
      UpdateMappingColumnMappingApiResponse,
      UpdateMappingColumnMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.mappingColumn,
      }),
    }),
    getMappingOtherScriptsMapping: build.query<
      GetMappingOtherScriptsMappingApiResponse,
      GetMappingOtherScriptsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/other-scripts`,
      }),
    }),
    updateMappingOtherScriptsMapping: build.mutation<
      UpdateMappingOtherScriptsMappingApiResponse,
      UpdateMappingOtherScriptsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/other-scripts`,
        method: "PUT",
        body: queryArg.mappingOtherScriptsDto,
      }),
    }),
    getMappingOverviewMapping: build.query<
      GetMappingOverviewMappingApiResponse,
      GetMappingOverviewMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/overview`,
      }),
    }),
    updateMappingOverviewMapping: build.mutation<
      UpdateMappingOverviewMappingApiResponse,
      UpdateMappingOverviewMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.mappingOverview,
      }),
    }),
    getMappingPermissionsMapping: build.query<
      GetMappingPermissionsMappingApiResponse,
      GetMappingPermissionsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/permission`,
      }),
    }),
    setMappingPermissionMapping: build.mutation<
      SetMappingPermissionMappingApiResponse,
      SetMappingPermissionMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.mappingPermission,
      }),
    }),
    deleteMappingPermissionMapping: build.mutation<
      DeleteMappingPermissionMappingApiResponse,
      DeleteMappingPermissionMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/permission/${queryArg.userCode}`,
        method: "DELETE",
      }),
    }),
    getMappingSourcesMapping: build.query<
      GetMappingSourcesMappingApiResponse,
      GetMappingSourcesMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources`,
      }),
    }),
    addMappingSourceItemMapping: build.mutation<
      AddMappingSourceItemMappingApiResponse,
      AddMappingSourceItemMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources`,
        method: "POST",
        body: queryArg.sourceItem,
      }),
    }),
    updateMappingSourceItemsMapping: build.mutation<
      UpdateMappingSourceItemsMappingApiResponse,
      UpdateMappingSourceItemsMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getMappingSourcesDataMapping: build.query<
      GetMappingSourcesDataMappingApiResponse,
      GetMappingSourcesDataMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources/data`,
      }),
    }),
    updateMappingSourcesDataMapping: build.mutation<
      UpdateMappingSourcesDataMappingApiResponse,
      UpdateMappingSourcesDataMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources/data`,
        method: "PUT",
        body: queryArg.mappingSourcesData,
      }),
    }),
    deleteMappingSourceItemMapping: build.mutation<
      DeleteMappingSourceItemMappingApiResponse,
      DeleteMappingSourceItemMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "DELETE",
      }),
    }),
    updateMappingSourceItemMapping: build.mutation<
      UpdateMappingSourceItemMappingApiResponse,
      UpdateMappingSourceItemMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/mapping/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "PUT",
        body: queryArg.sourceItem,
      }),
    }),
    rebaseBranch: build.mutation<RebaseBranchApiResponse, RebaseBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/rebase`,
        method: "POST",
        body: queryArg.branchRebaseRequestDto,
      }),
    }),
    getStructuresStructureV2: build.query<
      GetStructuresStructureV2ApiResponse,
      GetStructuresStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
          sortBy: queryArg.sortBy,
          appendIncluded: queryArg.appendIncluded,
        },
      }),
    }),
    generateScriptsStructureV2: build.mutation<
      GenerateScriptsStructureV2ApiResponse,
      GenerateScriptsStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/generate`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    bulkUnlockStructureV2: build.mutation<
      BulkUnlockStructureV2ApiResponse,
      BulkUnlockStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/lock`,
        method: "DELETE",
        params: {
          force: queryArg.force,
          id: queryArg.id,
        },
      }),
    }),
    bulkLockStructureV2: build.mutation<
      BulkLockStructureV2ApiResponse,
      BulkLockStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/lock`,
        method: "POST",
        params: {
          force: queryArg.force,
          id: queryArg.id,
        },
      }),
    }),
    searchTableColumnsStructureV2: build.query<
      SearchTableColumnsStructureV2ApiResponse,
      SearchTableColumnsStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/table/${queryArg.tableCode}/columns`,
        params: {
          searchText: queryArg.searchText,
          actualStructureId: queryArg.actualStructureId,
        },
      }),
    }),
    getFullTreeStructureV2: build.query<
      GetFullTreeStructureV2ApiResponse,
      GetFullTreeStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/tree`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
        },
      }),
    }),
    getChildrenStructureV2: build.query<
      GetChildrenStructureV2ApiResponse,
      GetChildrenStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.parentId}/children`,
        params: {
          type: queryArg["type"],
          search: queryArg.search,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
          maxLevel: queryArg.maxLevel,
        },
      }),
    }),
    createStructureStructureV2: build.mutation<
      CreateStructureStructureV2ApiResponse,
      CreateStructureStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.parentId}/children/${queryArg["type"]}`,
        method: "POST",
        params: {
          name: queryArg.name,
        },
      }),
    }),
    deleteStructureStructureV2: build.mutation<
      DeleteStructureStructureV2ApiResponse,
      DeleteStructureStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}`,
        method: "DELETE",
      }),
    }),
    getStructureMetadataStructureV2: build.query<
      GetStructureMetadataStructureV2ApiResponse,
      GetStructureMetadataStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}`,
      }),
    }),
    asyncStructurePreviewStructureV2: build.mutation<
      AsyncStructurePreviewStructureV2ApiResponse,
      AsyncStructurePreviewStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/async/preview`,
        method: "POST",
        params: {
          objectTypeId: queryArg.objectTypeId,
        },
      }),
    }),
    getStructureHistoryStructureV2: build.query<
      GetStructureHistoryStructureV2ApiResponse,
      GetStructureHistoryStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createStructureHistoryStructureV2: build.mutation<
      CreateStructureHistoryStructureV2ApiResponse,
      CreateStructureHistoryStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history`,
        method: "POST",
        params: {
          description: queryArg.description,
          fixImpacts: queryArg.fixImpacts,
        },
      }),
    }),
    prePushValidationStructureV2: build.query<
      PrePushValidationStructureV2ApiResponse,
      PrePushValidationStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history-validation`,
      }),
    }),
    compareStructureHistoryStructureV2: build.query<
      CompareStructureHistoryStructureV2ApiResponse,
      CompareStructureHistoryStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history/compare`,
        params: {
          leftHistoryId: queryArg.leftHistoryId,
          rightHistoryId: queryArg.rightHistoryId,
          includeUnchanged: queryArg.includeUnchanged,
        },
      }),
    }),
    getStructureHistoryWithDeploymentStructureV2: build.query<
      GetStructureHistoryWithDeploymentStructureV2ApiResponse,
      GetStructureHistoryWithDeploymentStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history/${queryArg.versionNumber}`,
      }),
    }),
    replaceStructureVersionStructureV2: build.mutation<
      ReplaceStructureVersionStructureV2ApiResponse,
      ReplaceStructureVersionStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/history/${queryArg.versionNumber}/restore`,
        method: "POST",
      }),
    }),
    unLockStructureStructureV2: build.mutation<
      UnLockStructureStructureV2ApiResponse,
      UnLockStructureStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/lock`,
        method: "DELETE",
      }),
    }),
    lockStructureStructureV2: build.mutation<
      LockStructureStructureV2ApiResponse,
      LockStructureStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/lock`,
        method: "POST",
      }),
    }),
    moveNodeStructureV2: build.mutation<
      MoveNodeStructureV2ApiResponse,
      MoveNodeStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/move/${queryArg.destinationStructureId}`,
        method: "PUT",
      }),
    }),
    getNodeRelationsRelation: build.query<
      GetNodeRelationsRelationApiResponse,
      GetNodeRelationsRelationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/relation`,
      }),
    }),
    createRelationRelation: build.mutation<
      CreateRelationRelationApiResponse,
      CreateRelationRelationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/relation`,
        method: "POST",
        body: queryArg.relationCreateDto,
      }),
    }),
    deleteRelationRelation: build.mutation<
      DeleteRelationRelationApiResponse,
      DeleteRelationRelationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "DELETE",
      }),
    }),
    patchRelationRelation: build.mutation<
      PatchRelationRelationApiResponse,
      PatchRelationRelationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "PATCH",
        body: queryArg.jsonPatch,
      }),
    }),
    updateRelationRelation: build.mutation<
      UpdateRelationRelationApiResponse,
      UpdateRelationRelationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "PUT",
        body: queryArg.relationDto,
      }),
    }),
    getParentSystemStructureV2: build.query<
      GetParentSystemStructureV2ApiResponse,
      GetParentSystemStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/system`,
      }),
    }),
    getStructureTreeStructureV2: build.query<
      GetStructureTreeStructureV2ApiResponse,
      GetStructureTreeStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureId}/tree`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
        },
      }),
    }),
    searchNodesWithTypeStructureV2: build.query<
      SearchNodesWithTypeStructureV2ApiResponse,
      SearchNodesWithTypeStructureV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/structure/${queryArg.structureType}/search`,
        params: {
          searchText: queryArg.searchText,
          actualStructureId: queryArg.actualStructureId,
        },
      }),
    }),
    getStructureDetailTable: build.query<
      GetStructureDetailTableApiResponse,
      GetStructureDetailTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateTableTable: build.mutation<
      UpdateTableTableApiResponse,
      UpdateTableTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.table,
      }),
    }),
    getTableColumnsTable: build.query<
      GetTableColumnsTableApiResponse,
      GetTableColumnsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/column`,
      }),
    }),
    addTableColumnTable: build.mutation<
      AddTableColumnTableApiResponse,
      AddTableColumnTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.tableColumn,
      }),
    }),
    updateTableColumnsTable: build.mutation<
      UpdateTableColumnsTableApiResponse,
      UpdateTableColumnsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableColumnTable: build.mutation<
      DeleteTableColumnTableApiResponse,
      DeleteTableColumnTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateTableColumnTable: build.mutation<
      UpdateTableColumnTableApiResponse,
      UpdateTableColumnTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.tableColumn,
      }),
    }),
    getTableConstraintsTable: build.query<
      GetTableConstraintsTableApiResponse,
      GetTableConstraintsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/constraint`,
      }),
    }),
    addTableConstraintTable: build.mutation<
      AddTableConstraintTableApiResponse,
      AddTableConstraintTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraintsTable: build.mutation<
      UpdateTableConstraintsTableApiResponse,
      UpdateTableConstraintsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraintTable: build.mutation<
      DeleteTableConstraintTableApiResponse,
      DeleteTableConstraintTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraintTable: build.mutation<
      UpdateTableConstraintTableApiResponse,
      UpdateTableConstraintTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getTableIndexesTable: build.query<
      GetTableIndexesTableApiResponse,
      GetTableIndexesTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/index`,
      }),
    }),
    addTableIndexTable: build.mutation<
      AddTableIndexTableApiResponse,
      AddTableIndexTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexesTable: build.mutation<
      UpdateTableIndexesTableApiResponse,
      UpdateTableIndexesTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndexTable: build.mutation<
      DeleteTableIndexTableApiResponse,
      DeleteTableIndexTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndexTable: build.mutation<
      UpdateTableIndexTableApiResponse,
      UpdateTableIndexTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverviewTable: build.query<
      GetTableOverviewTableApiResponse,
      GetTableOverviewTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/overview`,
      }),
    }),
    updateTableOverviewTable: build.mutation<
      UpdateTableOverviewTableApiResponse,
      UpdateTableOverviewTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyTable,
      }),
    }),
    deleteTablePermissionTable: build.mutation<
      DeleteTablePermissionTableApiResponse,
      DeleteTablePermissionTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissionsTable: build.query<
      GetTablePermissionsTableApiResponse,
      GetTablePermissionsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/permission`,
      }),
    }),
    setTablePermissionTable: build.mutation<
      SetTablePermissionTableApiResponse,
      SetTablePermissionTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getTableScriptsTable: build.query<
      GetTableScriptsTableApiResponse,
      GetTableScriptsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/scripts`,
      }),
    }),
    updateTableScriptsTable: build.mutation<
      UpdateTableScriptsTableApiResponse,
      UpdateTableScriptsTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/table/${queryArg.structureId}/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getStructureDetailView: build.query<
      GetStructureDetailViewApiResponse,
      GetStructureDetailViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateViewView: build.mutation<
      UpdateViewViewApiResponse,
      UpdateViewViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.view,
      }),
    }),
    getViewColumnsView: build.query<
      GetViewColumnsViewApiResponse,
      GetViewColumnsViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/column`,
      }),
    }),
    addViewColumnView: build.mutation<
      AddViewColumnViewApiResponse,
      AddViewColumnViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.viewColumn,
      }),
    }),
    updateViewColumnsView: build.mutation<
      UpdateViewColumnsViewApiResponse,
      UpdateViewColumnsViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    updateViewColumnView1: build.mutation<
      UpdateViewColumnView1ApiResponse,
      UpdateViewColumnView1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateViewColumnView: build.mutation<
      UpdateViewColumnViewApiResponse,
      UpdateViewColumnViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.viewColumn,
      }),
    }),
    getViewOverviewView: build.query<
      GetViewOverviewViewApiResponse,
      GetViewOverviewViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/overview`,
      }),
    }),
    updateViewOverviewView: build.mutation<
      UpdateViewOverviewViewApiResponse,
      UpdateViewOverviewViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.viewOverview,
      }),
    }),
    getViewPermissionsView: build.query<
      GetViewPermissionsViewApiResponse,
      GetViewPermissionsViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/permission`,
      }),
    }),
    setViewPermissionView: build.mutation<
      SetViewPermissionViewApiResponse,
      SetViewPermissionViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.viewPermission,
      }),
    }),
    deleteViewPermissionView: build.mutation<
      DeleteViewPermissionViewApiResponse,
      DeleteViewPermissionViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/permission/${queryArg.userCode}`,
        method: "DELETE",
      }),
    }),
    getViewSourcesView: build.query<
      GetViewSourcesViewApiResponse,
      GetViewSourcesViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources`,
      }),
    }),
    addViewSourceItemView: build.mutation<
      AddViewSourceItemViewApiResponse,
      AddViewSourceItemViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources`,
        method: "POST",
        body: queryArg.sourceItem,
      }),
    }),
    updateViewSourceItemsView: build.mutation<
      UpdateViewSourceItemsViewApiResponse,
      UpdateViewSourceItemsViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getViewSourcesDataView: build.query<
      GetViewSourcesDataViewApiResponse,
      GetViewSourcesDataViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources/data`,
      }),
    }),
    updateViewSourcesDataView: build.mutation<
      UpdateViewSourcesDataViewApiResponse,
      UpdateViewSourcesDataViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources/data`,
        method: "PUT",
        body: queryArg.viewSourcesData,
      }),
    }),
    deleteViewSourceItemView: build.mutation<
      DeleteViewSourceItemViewApiResponse,
      DeleteViewSourceItemViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "DELETE",
      }),
    }),
    updateViewSourceItemView: build.mutation<
      UpdateViewSourceItemViewApiResponse,
      UpdateViewSourceItemViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.branchId}/view/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "PUT",
        body: queryArg.sourceItem,
      }),
    }),
    getBranchChangesBetween: build.query<
      GetBranchChangesBetweenApiResponse,
      GetBranchChangesBetweenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.sourceBranchId}/changes/${queryArg.targetBranchId}`,
      }),
    }),
    createMergeRequest: build.mutation<
      CreateMergeRequestApiResponse,
      CreateMergeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.sourceBranchId}/merge/${queryArg.targetBranchId}`,
        method: "POST",
        body: queryArg.mergeRequestDto,
      }),
    }),
    getMergeRequestsForBranchPair: build.query<
      GetMergeRequestsForBranchPairApiResponse,
      GetMergeRequestsForBranchPairApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.sourceBranchId}/merge/${queryArg.targetBranchId}/requests`,
      }),
    }),
    getEventsForTargetBranch: build.query<
      GetEventsForTargetBranchApiResponse,
      GetEventsForTargetBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.targetBranchId}/merge-events`,
      }),
    }),
    getMergeRequestsForTargetBranch: build.query<
      GetMergeRequestsForTargetBranchApiResponse,
      GetMergeRequestsForTargetBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/branch/${queryArg.targetBranchId}/merge-requests`,
      }),
    }),
    deleteSystemRelease: build.mutation<
      DeleteSystemReleaseApiResponse,
      DeleteSystemReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}`,
        method: "DELETE",
      }),
    }),
    getSystemRelease: build.query<
      GetSystemReleaseApiResponse,
      GetSystemReleaseApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}` }),
    }),
    updateSystemRelease: build.mutation<
      UpdateSystemReleaseApiResponse,
      UpdateSystemReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}`,
        method: "PUT",
        body: queryArg.releaseDto,
      }),
    }),
    getReleaseEnvironments: build.query<
      GetReleaseEnvironmentsApiResponse,
      GetReleaseEnvironmentsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}/environment` }),
    }),
    createReleaseEnvironment: build.mutation<
      CreateReleaseEnvironmentApiResponse,
      CreateReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment`,
        method: "POST",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    deleteReleaseEnvironment: build.mutation<
      DeleteReleaseEnvironmentApiResponse,
      DeleteReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}`,
        method: "DELETE",
      }),
    }),
    updateReleaseEnvironment: build.mutation<
      UpdateReleaseEnvironmentApiResponse,
      UpdateReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}`,
        method: "PUT",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    pushReleaseToGit: build.mutation<
      PushReleaseToGitApiResponse,
      PushReleaseToGitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/git`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    createReleaseScripts: build.mutation<
      CreateReleaseScriptsApiResponse,
      CreateReleaseScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/scripts`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    createDeployments: build.mutation<
      CreateDeploymentsApiResponse,
      CreateDeploymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/scripts/deploy`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    getObjectSettings: build.query<
      GetObjectSettingsApiResponse,
      GetObjectSettingsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}/object-type` }),
    }),
    changeReleaseStatus: build.mutation<
      ChangeReleaseStatusApiResponse,
      ChangeReleaseStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/status/${queryArg.newStatus}`,
        method: "PATCH",
      }),
    }),
    getReleaseStructures: build.query<
      GetReleaseStructuresApiResponse,
      GetReleaseStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    addStructureToRelease: build.mutation<
      AddStructureToReleaseApiResponse,
      AddStructureToReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteReleaseStructure: build.mutation<
      DeleteReleaseStructureApiResponse,
      DeleteReleaseStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure/${queryArg.structureId}`,
        method: "DELETE",
      }),
    }),
    getProviders: build.query<GetProvidersApiResponse, GetProvidersApiArg>({
      query: () => ({ url: `/v2/expectation-providers` }),
    }),
    getExpectations: build.query<
      GetExpectationsApiResponse,
      GetExpectationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expectations`,
        params: {
          providerCode: queryArg.providerCode,
          active: queryArg.active,
        },
      }),
    }),
    importStructureCsvIntoNode: build.mutation<
      ImportStructureCsvIntoNodeApiResponse,
      ImportStructureCsvIntoNodeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/csv/branch/${queryArg.branchId}/folder/${queryArg.structureId}`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
          importAllColumns: queryArg.importAllColumns,
        },
      }),
    }),
    importStructureCsvIntoNodeCheck: build.mutation<
      ImportStructureCsvIntoNodeCheckApiResponse,
      ImportStructureCsvIntoNodeCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/csv/branch/${queryArg.branchId}/folder/${queryArg.structureId}/check`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
          importAllColumns: queryArg.importAllColumns,
        },
      }),
    }),
    importColumnsFromCsv: build.mutation<
      ImportColumnsFromCsvApiResponse,
      ImportColumnsFromCsvApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/csv/branch/${queryArg.branchId}/table/${queryArg.structureId}/columns`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
          importAllColumns: queryArg.importAllColumns,
        },
      }),
    }),
    importColumnsFromCsvCheck: build.mutation<
      ImportColumnsFromCsvCheckApiResponse,
      ImportColumnsFromCsvCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/csv/branch/${queryArg.branchId}/table/${queryArg.structureId}/columns/check`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
          importAllColumns: queryArg.importAllColumns,
        },
      }),
    }),
    importStructures: build.mutation<
      ImportStructuresApiResponse,
      ImportStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/json`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          branchId: queryArg.branchId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    checkJson: build.mutation<CheckJsonApiResponse, CheckJsonApiArg>({
      query: (queryArg) => ({
        url: `/v2/import/json/check`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          branchId: queryArg.branchId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    getImportResult: build.query<
      GetImportResultApiResponse,
      GetImportResultApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import/json/${queryArg.taskId}/result`,
      }),
    }),
    getAllLovAcronym: build.query<
      GetAllLovAcronymApiResponse,
      GetAllLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovAcronym: build.mutation<
      CreateLovAcronymApiResponse,
      CreateLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym`,
        method: "POST",
        body: queryArg.acronymDto,
      }),
    }),
    deleteLovAcronym: build.mutation<
      DeleteLovAcronymApiResponse,
      DeleteLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovAcronym: build.query<GetLovAcronymApiResponse, GetLovAcronymApiArg>({
      query: (queryArg) => ({ url: `/v2/lov/acronym/${queryArg.id}` }),
    }),
    updateLovAcronym: build.mutation<
      UpdateLovAcronymApiResponse,
      UpdateLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym/${queryArg.id}`,
        method: "PUT",
        body: queryArg.acronymDto,
      }),
    }),
    getAllLovBusinessDomain: build.query<
      GetAllLovBusinessDomainApiResponse,
      GetAllLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovBusinessDomain: build.mutation<
      CreateLovBusinessDomainApiResponse,
      CreateLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain`,
        method: "POST",
        body: queryArg.businessDomainDto,
      }),
    }),
    deleteLovBusinessDomain: build.mutation<
      DeleteLovBusinessDomainApiResponse,
      DeleteLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovBusinessDomain: build.query<
      GetLovBusinessDomainApiResponse,
      GetLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/business-domain/${queryArg.id}` }),
    }),
    updateLovBusinessDomain: build.mutation<
      UpdateLovBusinessDomainApiResponse,
      UpdateLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain/${queryArg.id}`,
        method: "PUT",
        body: queryArg.businessDomainDto,
      }),
    }),
    getAllLovCustomAttributeGroup: build.query<
      GetAllLovCustomAttributeGroupApiResponse,
      GetAllLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttributeGroup: build.mutation<
      CreateLovCustomAttributeGroupApiResponse,
      CreateLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp`,
        method: "POST",
        body: queryArg.customAttributeGroupDto,
      }),
    }),
    deleteLovCustomAttributeGroup: build.mutation<
      DeleteLovCustomAttributeGroupApiResponse,
      DeleteLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttributeGroup: build.query<
      GetLovCustomAttributeGroupApiResponse,
      GetLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attr-grp/${queryArg.id}` }),
    }),
    updateLovCustomAttributeGroup: build.mutation<
      UpdateLovCustomAttributeGroupApiResponse,
      UpdateLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customAttributeGroupDto,
      }),
    }),
    getAllLovCustomAttributeLov: build.query<
      GetAllLovCustomAttributeLovApiResponse,
      GetAllLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttributeLov: build.mutation<
      CreateLovCustomAttributeLovApiResponse,
      CreateLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov`,
        method: "POST",
        body: queryArg.customLovDto,
      }),
    }),
    downloadCustomLovsLovCustomAttributeLov: build.query<
      DownloadCustomLovsLovCustomAttributeLovApiResponse,
      DownloadCustomLovsLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/export`,
        params: {
          search: queryArg.search,
        },
      }),
    }),
    deleteLovCustomAttributeLov: build.mutation<
      DeleteLovCustomAttributeLovApiResponse,
      DeleteLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttributeLov: build.query<
      GetLovCustomAttributeLovApiResponse,
      GetLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attr-lov/${queryArg.id}` }),
    }),
    updateLovCustomAttributeLov: build.mutation<
      UpdateLovCustomAttributeLovApiResponse,
      UpdateLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customLovDto,
      }),
    }),
    getAllLovCustomAttribute: build.query<
      GetAllLovCustomAttributeApiResponse,
      GetAllLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute`,
        params: {
          search: queryArg.search,
          structureType: queryArg.structureType,
          stereotypeId: queryArg.stereotypeId,
          stereotypeCode: queryArg.stereotypeCode,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttribute: build.mutation<
      CreateLovCustomAttributeApiResponse,
      CreateLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute`,
        method: "POST",
        body: queryArg.customAttributeDto,
      }),
    }),
    deleteLovCustomAttribute: build.mutation<
      DeleteLovCustomAttributeApiResponse,
      DeleteLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttribute: build.query<
      GetLovCustomAttributeApiResponse,
      GetLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attribute/${queryArg.id}` }),
    }),
    updateLovCustomAttribute: build.mutation<
      UpdateLovCustomAttributeApiResponse,
      UpdateLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customAttributeDto,
      }),
    }),
    getAllLovDomain: build.query<
      GetAllLovDomainApiResponse,
      GetAllLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain`,
        params: {
          search: queryArg.search,
          dataType: queryArg.dataType,
          technologyId: queryArg.technologyId,
          technologyCode: queryArg.technologyCode,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovDomain: build.mutation<
      CreateLovDomainApiResponse,
      CreateLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain`,
        method: "POST",
        body: queryArg.domainV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    deleteLovDomain: build.mutation<
      DeleteLovDomainApiResponse,
      DeleteLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}`,
        method: "DELETE",
        params: {
          update: queryArg.update,
        },
      }),
    }),
    getLovDomain: build.query<GetLovDomainApiResponse, GetLovDomainApiArg>({
      query: (queryArg) => ({ url: `/v2/lov/domain/${queryArg.id}` }),
    }),
    updateLovDomain: build.mutation<
      UpdateLovDomainApiResponse,
      UpdateLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}`,
        method: "PUT",
        body: queryArg.domainV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    computeImpactDomainChangeLovDomain: build.mutation<
      ComputeImpactDomainChangeLovDomainApiResponse,
      ComputeImpactDomainChangeLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}/impact`,
        method: "POST",
        body: queryArg.domainUpdateDto,
      }),
    }),
    getAllLovObjectType: build.query<
      GetAllLovObjectTypeApiResponse,
      GetAllLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type`,
        params: {
          search: queryArg.search,
          structureType: queryArg.structureType,
          defaultFlag: queryArg.defaultFlag,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovObjectType: build.mutation<
      CreateLovObjectTypeApiResponse,
      CreateLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type`,
        method: "POST",
        body: queryArg.objectSettingsDto,
      }),
    }),
    deleteLovObjectType: build.mutation<
      DeleteLovObjectTypeApiResponse,
      DeleteLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovObjectType: build.query<
      GetLovObjectTypeApiResponse,
      GetLovObjectTypeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/object-type/${queryArg.id}` }),
    }),
    updateLovObjectType: build.mutation<
      UpdateLovObjectTypeApiResponse,
      UpdateLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type/${queryArg.id}`,
        method: "PUT",
        body: queryArg.objectSettingsDto,
      }),
    }),
    getAllLovStereotype: build.query<
      GetAllLovStereotypeApiResponse,
      GetAllLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype`,
        params: {
          search: queryArg.search,
          type: queryArg["type"],
          category: queryArg.category,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovStereotype: build.mutation<
      CreateLovStereotypeApiResponse,
      CreateLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype`,
        method: "POST",
        body: queryArg.stereotypeV2Dto,
      }),
    }),
    deleteLovStereotype: build.mutation<
      DeleteLovStereotypeApiResponse,
      DeleteLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovStereotype: build.query<
      GetLovStereotypeApiResponse,
      GetLovStereotypeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/stereotype/${queryArg.id}` }),
    }),
    updateLovStereotype: build.mutation<
      UpdateLovStereotypeApiResponse,
      UpdateLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype/${queryArg.id}`,
        method: "PUT",
        body: queryArg.stereotypeV2Dto,
      }),
    }),
    getAllLovTechnicalColumn: build.query<
      GetAllLovTechnicalColumnApiResponse,
      GetAllLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column`,
        params: {
          search: queryArg.search,
          stereotypeId: queryArg.stereotypeId,
          stereotypeCode: queryArg.stereotypeCode,
          updatedBy: queryArg.updatedBy,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovTechnicalColumn: build.mutation<
      CreateLovTechnicalColumnApiResponse,
      CreateLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column`,
        method: "POST",
        body: queryArg.technicalColumnV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    deleteLovTechnicalColumn: build.mutation<
      DeleteLovTechnicalColumnApiResponse,
      DeleteLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}`,
        method: "DELETE",
        params: {
          update: queryArg.update,
        },
      }),
    }),
    getLovTechnicalColumn: build.query<
      GetLovTechnicalColumnApiResponse,
      GetLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/technical-column/${queryArg.id}` }),
    }),
    updateLovTechnicalColumn: build.mutation<
      UpdateLovTechnicalColumnApiResponse,
      UpdateLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}`,
        method: "PUT",
        body: queryArg.technicalColumnV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    computeImpactTcChangeLovTechnicalColumn: build.mutation<
      ComputeImpactTcChangeLovTechnicalColumnApiResponse,
      ComputeImpactTcChangeLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}/impact`,
        method: "POST",
        body: queryArg.technicalColumnV2Dto,
      }),
    }),
    getAllLovTechnology: build.query<
      GetAllLovTechnologyApiResponse,
      GetAllLovTechnologyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technology`,
        params: {
          type: queryArg["type"],
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getMergeRequest: build.query<
      GetMergeRequestApiResponse,
      GetMergeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}`,
      }),
    }),
    getApprovals: build.query<GetApprovalsApiResponse, GetApprovalsApiArg>({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/approvals`,
      }),
    }),
    saveResolution: build.mutation<
      SaveResolutionApiResponse,
      SaveResolutionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/conflict-resolution`,
        method: "POST",
        params: {
          structureId: queryArg.structureId,
          fieldPath: queryArg.fieldPath,
          sourceValue: queryArg.sourceValue,
          targetValue: queryArg.targetValue,
          selectedValue: queryArg.selectedValue,
          resolution: queryArg.resolution,
        },
      }),
    }),
    getResolutions: build.query<
      GetResolutionsApiResponse,
      GetResolutionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/conflict-resolutions`,
      }),
    }),
    decide: build.mutation<DecideApiResponse, DecideApiArg>({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/decision`,
        method: "POST",
        params: {
          decision: queryArg.decision,
          comment: queryArg.comment,
        },
      }),
    }),
    executeMerge: build.mutation<ExecuteMergeApiResponse, ExecuteMergeApiArg>({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/execute`,
        method: "POST",
      }),
    }),
    getEventsForMergeRequest: build.query<
      GetEventsForMergeRequestApiResponse,
      GetEventsForMergeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/merge-events`,
      }),
    }),
    recalculateDiff: build.mutation<
      RecalculateDiffApiResponse,
      RecalculateDiffApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/recalculate`,
        method: "PUT",
      }),
    }),
    markStale: build.mutation<MarkStaleApiResponse, MarkStaleApiArg>({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/stale`,
        method: "PUT",
        params: {
          staleReason: queryArg.staleReason,
        },
      }),
    }),
    updateMergeRequestStatus: build.mutation<
      UpdateMergeRequestStatusApiResponse,
      UpdateMergeRequestStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/merge-request/${queryArg.mergeRequestId}/status`,
        method: "PUT",
        params: {
          status: queryArg.status,
        },
      }),
    }),
    getSecrets: build.query<GetSecretsApiResponse, GetSecretsApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    createSecret: build.mutation<CreateSecretApiResponse, CreateSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret`,
        method: "POST",
        body: queryArg.secretDto,
      }),
    }),
    deleteSecret: build.mutation<DeleteSecretApiResponse, DeleteSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret/${queryArg.secretId}`,
        method: "DELETE",
      }),
    }),
    getSecret: build.query<GetSecretApiResponse, GetSecretApiArg>({
      query: (queryArg) => ({ url: `/v2/secret/${queryArg.secretId}` }),
    }),
    updateSecret: build.mutation<UpdateSecretApiResponse, UpdateSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret/${queryArg.secretId}`,
        method: "PUT",
        body: queryArg.secretDto,
      }),
    }),
    createSystem: build.mutation<CreateSystemApiResponse, CreateSystemApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure`,
        method: "POST",
        body: queryArg.system,
      }),
    }),
    getSystems: build.query<GetSystemsApiResponse, GetSystemsApiArg>({
      query: () => ({ url: `/v2/structure/system` }),
    }),
    getDeletedStructures: build.query<
      GetDeletedStructuresApiResponse,
      GetDeletedStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/trash`,
        params: {
          search: queryArg.search,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    undeleteStructure: build.mutation<
      UndeleteStructureApiResponse,
      UndeleteStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/trash/${queryArg.structureId}/restore`,
        method: "POST",
        params: {
          newParentId: queryArg.newParentId,
        },
      }),
    }),
    getStructureAcl: build.query<
      GetStructureAclApiResponse,
      GetStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl`,
      }),
    }),
    createStructureAcl: build.mutation<
      CreateStructureAclApiResponse,
      CreateStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl`,
        method: "POST",
        body: queryArg.aclEntryDto,
      }),
    }),
    getEffectiveAcl: build.query<
      GetEffectiveAclApiResponse,
      GetEffectiveAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/effective`,
      }),
    }),
    evaluatePermissions: build.query<
      EvaluatePermissionsApiResponse,
      EvaluatePermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/evaluate`,
        params: {
          forUserId: queryArg.forUserId,
          groupName: queryArg.groupName,
        },
      }),
    }),
    deleteStructureAcl: build.mutation<
      DeleteStructureAclApiResponse,
      DeleteStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/${queryArg.aclId}`,
        method: "DELETE",
      }),
    }),
    updateStructureAcl: build.mutation<
      UpdateStructureAclApiResponse,
      UpdateStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/${queryArg.aclId}`,
        method: "PUT",
        body: queryArg.aclEntryDto,
      }),
    }),
    count: build.query<CountApiResponse, CountApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/count`,
      }),
    }),
    getStructureHistoryById: build.query<
      GetStructureHistoryByIdApiResponse,
      GetStructureHistoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history/${queryArg.versionId}`,
      }),
    }),
    getBranches: build.query<GetBranchesApiResponse, GetBranchesApiArg>({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/branch`,
        params: {
          search: queryArg.search,
          status: queryArg.status,
          protectedBranch: queryArg.protectedBranch,
          selfApprovalAllowed: queryArg.selfApprovalAllowed,
          sourceBranchId: queryArg.sourceBranchId,
          sourceDeploymentPackageId: queryArg.sourceDeploymentPackageId,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createBranch: build.mutation<CreateBranchApiResponse, CreateBranchApiArg>({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/branch`,
        method: "POST",
        body: queryArg.branchDto,
      }),
    }),
    getDeploymentPackages: build.query<
      GetDeploymentPackagesApiResponse,
      GetDeploymentPackagesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/deployment-package`,
        params: {
          status: queryArg.status,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createDeploymentPackage: build.mutation<
      CreateDeploymentPackageApiResponse,
      CreateDeploymentPackageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/deployment-package`,
        method: "POST",
        body: queryArg.releaseDto,
      }),
    }),
    getEnvGitBranches: build.query<
      GetEnvGitBranchesApiResponse,
      GetEnvGitBranchesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/env/${queryArg.envCode}/git-branche`,
      }),
    }),
    getMergeRequestsInSystem: build.query<
      GetMergeRequestsInSystemApiResponse,
      GetMergeRequestsInSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/merge-requests`,
        params: {
          sourceBranchId: queryArg.sourceBranchId,
          targetBranchId: queryArg.targetBranchId,
          status: queryArg.status,
          authorId: queryArg.authorId,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getStructureDetailTableHistory: build.query<
      GetStructureDetailTableHistoryApiResponse,
      GetStructureDetailTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateTableTableHistory: build.mutation<
      UpdateTableTableHistoryApiResponse,
      UpdateTableTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history`,
        method: "PUT",
        body: queryArg.historyTable,
      }),
    }),
    getTableColumnsTableHistory: build.query<
      GetTableColumnsTableHistoryApiResponse,
      GetTableColumnsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/column`,
      }),
    }),
    getTableConstraintsTableHistory: build.query<
      GetTableConstraintsTableHistoryApiResponse,
      GetTableConstraintsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
      }),
    }),
    addTableConstraintTableHistory: build.mutation<
      AddTableConstraintTableHistoryApiResponse,
      AddTableConstraintTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraintsTableHistory: build.mutation<
      UpdateTableConstraintsTableHistoryApiResponse,
      UpdateTableConstraintsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraintTableHistory: build.mutation<
      DeleteTableConstraintTableHistoryApiResponse,
      DeleteTableConstraintTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraintTableHistory: build.mutation<
      UpdateTableConstraintTableHistoryApiResponse,
      UpdateTableConstraintTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getTableIndexesTableHistory: build.query<
      GetTableIndexesTableHistoryApiResponse,
      GetTableIndexesTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
      }),
    }),
    addTableIndexTableHistory: build.mutation<
      AddTableIndexTableHistoryApiResponse,
      AddTableIndexTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexesTableHistory: build.mutation<
      UpdateTableIndexesTableHistoryApiResponse,
      UpdateTableIndexesTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndexTableHistory: build.mutation<
      DeleteTableIndexTableHistoryApiResponse,
      DeleteTableIndexTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndexTableHistory: build.mutation<
      UpdateTableIndexTableHistoryApiResponse,
      UpdateTableIndexTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverviewTableHistory: build.query<
      GetTableOverviewTableHistoryApiResponse,
      GetTableOverviewTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/overview`,
      }),
    }),
    updateTableOverviewTableHistory: build.mutation<
      UpdateTableOverviewTableHistoryApiResponse,
      UpdateTableOverviewTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyHistoryTable,
      }),
    }),
    deleteTablePermissionTableHistory: build.mutation<
      DeleteTablePermissionTableHistoryApiResponse,
      DeleteTablePermissionTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissionsTableHistory: build.query<
      GetTablePermissionsTableHistoryApiResponse,
      GetTablePermissionsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
      }),
    }),
    setTablePermissionTableHistory: build.mutation<
      SetTablePermissionTableHistoryApiResponse,
      SetTablePermissionTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getTableScriptsTableHistory: build.query<
      GetTableScriptsTableHistoryApiResponse,
      GetTableScriptsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/scripts`,
      }),
    }),
    updateTableScriptsTableHistory: build.mutation<
      UpdateTableScriptsTableHistoryApiResponse,
      UpdateTableScriptsTableHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getStructureDetailTableReference: build.query<
      GetStructureDetailTableReferenceApiResponse,
      GetStructureDetailTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference`,
        params: {
          versionNumber: queryArg.versionNumber,
        },
      }),
    }),
    updateTableTableReference: build.mutation<
      UpdateTableTableReferenceApiResponse,
      UpdateTableTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference`,
        method: "PUT",
        body: queryArg.referenceTable,
      }),
    }),
    getTableColumnsTableReference: build.query<
      GetTableColumnsTableReferenceApiResponse,
      GetTableColumnsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/column`,
      }),
    }),
    getTableConstraintsTableReference: build.query<
      GetTableConstraintsTableReferenceApiResponse,
      GetTableConstraintsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
      }),
    }),
    addTableConstraintTableReference: build.mutation<
      AddTableConstraintTableReferenceApiResponse,
      AddTableConstraintTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraintsTableReference: build.mutation<
      UpdateTableConstraintsTableReferenceApiResponse,
      UpdateTableConstraintsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraintTableReference: build.mutation<
      DeleteTableConstraintTableReferenceApiResponse,
      DeleteTableConstraintTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraintTableReference: build.mutation<
      UpdateTableConstraintTableReferenceApiResponse,
      UpdateTableConstraintTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getTableIndexesTableReference: build.query<
      GetTableIndexesTableReferenceApiResponse,
      GetTableIndexesTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
      }),
    }),
    addTableIndexTableReference: build.mutation<
      AddTableIndexTableReferenceApiResponse,
      AddTableIndexTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexesTableReference: build.mutation<
      UpdateTableIndexesTableReferenceApiResponse,
      UpdateTableIndexesTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndexTableReference: build.mutation<
      DeleteTableIndexTableReferenceApiResponse,
      DeleteTableIndexTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndexTableReference: build.mutation<
      UpdateTableIndexTableReferenceApiResponse,
      UpdateTableIndexTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverviewTableReference: build.query<
      GetTableOverviewTableReferenceApiResponse,
      GetTableOverviewTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/overview`,
      }),
    }),
    updateTableOverviewTableReference: build.mutation<
      UpdateTableOverviewTableReferenceApiResponse,
      UpdateTableOverviewTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyTable,
      }),
    }),
    deleteTablePermissionTableReference: build.mutation<
      DeleteTablePermissionTableReferenceApiResponse,
      DeleteTablePermissionTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissionsTableReference: build.query<
      GetTablePermissionsTableReferenceApiResponse,
      GetTablePermissionsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
      }),
    }),
    setTablePermissionTableReference: build.mutation<
      SetTablePermissionTableReferenceApiResponse,
      SetTablePermissionTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getTableScriptsTableReference: build.query<
      GetTableScriptsTableReferenceApiResponse,
      GetTableScriptsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/scripts`,
      }),
    }),
    updateTableScriptsTableReference: build.mutation<
      UpdateTableScriptsTableReferenceApiResponse,
      UpdateTableScriptsTableReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getAllTemplates: build.query<
      GetAllTemplatesApiResponse,
      GetAllTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates`,
        params: {
          technologyId: queryArg.technologyId,
          stereotypeId: queryArg.stereotypeId,
        },
      }),
    }),
    createTemplate: build.mutation<
      CreateTemplateApiResponse,
      CreateTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates`,
        method: "POST",
        body: queryArg.templateDto,
      }),
    }),
    deleteTemplate: build.mutation<
      DeleteTemplateApiResponse,
      DeleteTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getTemplate: build.query<GetTemplateApiResponse, GetTemplateApiArg>({
      query: (queryArg) => ({ url: `/v2/templates/${queryArg.id}` }),
    }),
    updateTemplate: build.mutation<
      UpdateTemplateApiResponse,
      UpdateTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}`,
        method: "PUT",
        body: queryArg.templateDto,
      }),
    }),
    getTemplateHistory: build.query<
      GetTemplateHistoryApiResponse,
      GetTemplateHistoryApiArg
    >({
      query: (queryArg) => ({ url: `/v2/templates/${queryArg.id}/history` }),
    }),
    getTemplateHistoryDetail: build.query<
      GetTemplateHistoryDetailApiResponse,
      GetTemplateHistoryDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}/history/${queryArg.version}`,
      }),
    }),
    postTemplateLock: build.mutation<
      PostTemplateLockApiResponse,
      PostTemplateLockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/lock`,
        method: "POST",
      }),
    }),
    postTemplatePush: build.mutation<
      PostTemplatePushApiResponse,
      PostTemplatePushApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/push`,
        method: "POST",
        params: {
          unlock: queryArg.unlock,
        },
      }),
    }),
    postTemplateUnlock: build.mutation<
      PostTemplateUnlockApiResponse,
      PostTemplateUnlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/unlock`,
        method: "POST",
      }),
    }),
    getTenant: build.query<GetTenantApiResponse, GetTenantApiArg>({
      query: () => ({ url: `/v2/tenant` }),
    }),
    updateTenant: build.mutation<UpdateTenantApiResponse, UpdateTenantApiArg>({
      query: (queryArg) => ({
        url: `/v2/tenant`,
        method: "PUT",
        body: queryArg.tenantDto,
      }),
    }),
    getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
      query: (queryArg) => ({
        url: `/v2/user`,
        params: {
          search: queryArg.search,
          type: queryArg["type"],
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    addUser: build.mutation<AddUserApiResponse, AddUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user`,
        method: "POST",
        body: queryArg.userDto,
        params: {
          password: queryArg.password,
        },
      }),
    }),
    getApiUsers: build.query<GetApiUsersApiResponse, GetApiUsersApiArg>({
      query: () => ({ url: `/v2/user/api` }),
    }),
    addApiUser: build.mutation<AddApiUserApiResponse, AddApiUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/api`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    deleteApiUser: build.mutation<
      DeleteApiUserApiResponse,
      DeleteApiUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}`,
        method: "DELETE",
      }),
    }),
    apiUserUpdate: build.mutation<
      ApiUserUpdateApiResponse,
      ApiUserUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    apiUserResetSecret: build.mutation<
      ApiUserResetSecretApiResponse,
      ApiUserResetSecretApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}/reset-secret`,
        method: "POST",
      }),
    }),
    getSessionContext: build.query<
      GetSessionContextApiResponse,
      GetSessionContextApiArg
    >({
      query: () => ({ url: `/v2/user/context` }),
    }),
    updateSessionContext: build.mutation<
      UpdateSessionContextApiResponse,
      UpdateSessionContextApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/context`,
        method: "PUT",
        body: queryArg.sessionContextDto,
      }),
    }),
    getGroups: build.query<GetGroupsApiResponse, GetGroupsApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group`,
        params: {
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group`,
        method: "POST",
        body: queryArg.groupDto,
      }),
    }),
    deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}`,
        method: "PUT",
        body: queryArg.groupDto,
      }),
    }),
    getRolesForGroup: build.query<
      GetRolesForGroupApiResponse,
      GetRolesForGroupApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user/group/${queryArg.groupId}/role` }),
    }),
    setRolesForGroup: build.mutation<
      SetRolesForGroupApiResponse,
      SetRolesForGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/role`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    removeUserFromGroup: build.mutation<
      RemoveUserFromGroupApiResponse,
      RemoveUserFromGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        method: "DELETE",
        params: {
          userId: queryArg.userId,
        },
      }),
    }),
    getUsersInGroup: build.query<
      GetUsersInGroupApiResponse,
      GetUsersInGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        params: {
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    addUserToGroup: build.mutation<
      AddUserToGroupApiResponse,
      AddUserToGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        method: "POST",
        params: {
          userId: queryArg.userId,
        },
      }),
    }),
    getUserList: build.query<GetUserListApiResponse, GetUserListApiArg>({
      query: () => ({ url: `/v2/user/list` }),
    }),
    deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getUser: build.query<GetUserApiResponse, GetUserApiArg>({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}` }),
    }),
    editUser: build.mutation<EditUserApiResponse, EditUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.userDto,
      }),
    }),
    getUserGroups: build.query<GetUserGroupsApiResponse, GetUserGroupsApiArg>({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}/group` }),
    }),
    unLockUser: build.mutation<UnLockUserApiResponse, UnLockUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/lock`,
        method: "DELETE",
      }),
    }),
    lockUser: build.mutation<LockUserApiResponse, LockUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/lock`,
        method: "POST",
      }),
    }),
    resetPassword: build.mutation<
      ResetPasswordApiResponse,
      ResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/reset-password`,
        method: "POST",
      }),
    }),
    getRolesForUser: build.query<
      GetRolesForUserApiResponse,
      GetRolesForUserApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}/role` }),
    }),
    setRolesForUser: build.mutation<
      SetRolesForUserApiResponse,
      SetRolesForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/role`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as mddApiSliceGeneratedV2 };
export type GetProvidersAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead[];
export type GetProvidersAdminApiArg = void;
export type CreateProviderAdminApiResponse =
  /** status 201 Created */ ExpectationProviderDtoRead;
export type CreateProviderAdminApiArg = {
  expectationProviderDto: ExpectationProviderDto;
};
export type DeleteProviderAdminApiResponse = unknown;
export type DeleteProviderAdminApiArg = {
  providerId: number;
};
export type GetProviderAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead;
export type GetProviderAdminApiArg = {
  providerId: number;
};
export type UpdateProviderAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead;
export type UpdateProviderAdminApiArg = {
  providerId: number;
  expectationProviderDto: ExpectationProviderDto;
};
export type GetExpectationsAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead[];
export type GetExpectationsAdminApiArg = {
  /** Provider code */
  providerCode?: string;
};
export type CreateExpectationAdminApiResponse =
  /** status 201 Created */ ExpectationAdminDtoRead;
export type CreateExpectationAdminApiArg = {
  expectationAdminDto: ExpectationAdminDto;
};
export type DeleteExpectationAdminApiResponse = unknown;
export type DeleteExpectationAdminApiArg = {
  expectationId: number;
};
export type GetExpectationAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead;
export type GetExpectationAdminApiArg = {
  expectationId: number;
};
export type UpdateExpectationAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead;
export type UpdateExpectationAdminApiArg = {
  expectationId: number;
  expectationAdminDto: ExpectationAdminDto;
};
export type DeleteBranchApiResponse = unknown;
export type DeleteBranchApiArg = {
  branchId: number;
};
export type GetBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type GetBranchApiArg = {
  branchId: number;
};
export type UpdateBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type UpdateBranchApiArg = {
  branchId: number;
  branchDto: BranchDto;
};
export type ActivateBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type ActivateBranchApiArg = {
  branchId: number;
};
export type ArchiveBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type ArchiveBranchApiArg = {
  branchId: number;
};
export type GetBranchChangesApiResponse =
  /** status 200 OK */ BranchStructureChangeDto[];
export type GetBranchChangesApiArg = {
  branchId: number;
};
export type CherryPickApiResponse =
  /** status 200 OK */ BranchCherryPickResultDto;
export type CherryPickApiArg = {
  branchId: number;
  branchCherryPickRequestDto: BranchCherryPickRequestDto;
};
export type PreviewCherryPickApiResponse =
  /** status 200 OK */ BranchCherryPickResultDto;
export type PreviewCherryPickApiArg = {
  branchId: number;
  branchCherryPickRequestDto: BranchCherryPickRequestDto;
};
export type UpdateDeploymentPackageApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type UpdateDeploymentPackageApiArg = {
  branchId: number;
};
export type GetDataForDiagramApiResponse =
  /** status 200 OK */ DiagramDataResponseRead;
export type GetDataForDiagramApiArg = {
  branchId: number;
  tableIds: number[];
};
export type GetDiagramByIdApiResponse = /** status 200 OK */ NewDiagram;
export type GetDiagramByIdApiArg = {
  branchId: number;
  structureId: number;
  version?: string;
};
export type UpdateDiagramApiResponse = unknown;
export type UpdateDiagramApiArg = {
  branchId: number;
  structureId: number;
  newDiagram: NewDiagram;
};
export type GetDiagramDataApiResponse = /** status 200 OK */ Diagram;
export type GetDiagramDataApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateDiagramDataApiResponse = /** status 200 OK */ Diagram;
export type UpdateDiagramDataApiArg = {
  branchId: number;
  structureId: number;
  diagram: Diagram;
};
export type GetDiagramOverviewApiResponse =
  /** status 200 OK */ DiagramOverviewRead;
export type GetDiagramOverviewApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateDiagramOverviewApiResponse =
  /** status 200 OK */ DiagramOverviewRead;
export type UpdateDiagramOverviewApiArg = {
  branchId: number;
  structureId: number;
  diagramOverview: DiagramOverview;
};
export type GetDiagramSvgApiResponse = unknown;
export type GetDiagramSvgApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateDiagramSvgApiResponse = unknown;
export type UpdateDiagramSvgApiArg = {
  branchId: number;
  structureId: number;
  body: string;
};
export type GetStructureDetailFolderApiResponse = /** status 200 OK */ Folder;
export type GetStructureDetailFolderApiArg = {
  structureId: number;
  branchId: number;
  versionNumber?: string;
};
export type UpdateFolderFolderApiResponse = unknown;
export type UpdateFolderFolderApiArg = {
  branchId: number;
  structureId: number;
  folder: Folder;
};
export type GetOdcsFolderApiResponse = /** status 200 OK */ BasicData;
export type GetOdcsFolderApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateOdcsFolderApiResponse = /** status 200 OK */ BasicData;
export type UpdateOdcsFolderApiArg = {
  branchId: number;
  structureId: number;
  basicData: BasicData;
};
export type SetOdcsStatusFolderApiResponse = unknown;
export type SetOdcsStatusFolderApiArg = {
  branchId: number;
  structureId: number;
  newStatus: StatusEnum;
};
export type GetFolderOverviewFolderApiResponse =
  /** status 200 OK */ FolderOverviewRead;
export type GetFolderOverviewFolderApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateFolderOverviewFolderApiResponse =
  /** status 200 OK */ FolderOverviewRead;
export type UpdateFolderOverviewFolderApiArg = {
  branchId: number;
  structureId: number;
  folderOverview: FolderOverview;
};
export type UnlockBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type UnlockBranchApiArg = {
  branchId: number;
};
export type LockBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type LockBranchApiArg = {
  branchId: number;
};
export type GetStructureDetailMappingApiResponse = /** status 200 OK */ Mapping;
export type GetStructureDetailMappingApiArg = {
  structureId: number;
  branchId: number;
  versionNumber?: string;
};
export type UpdateMappingMappingApiResponse = unknown;
export type UpdateMappingMappingApiArg = {
  branchId: number;
  structureId: number;
  mapping: Mapping;
};
export type GetMappingColumnsMappingApiResponse =
  /** status 200 OK */ MappingColumn[];
export type GetMappingColumnsMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type AddMappingColumnMappingApiResponse =
  /** status 200 OK */ MappingColumn;
export type AddMappingColumnMappingApiArg = {
  branchId: number;
  structureId: number;
  mappingColumn: MappingColumn;
};
export type UpdateMappingColumnsMappingApiResponse =
  /** status 200 OK */ MappingColumn[];
export type UpdateMappingColumnsMappingApiArg = {
  branchId: number;
  structureId: number;
  body: MappingColumn[];
};
export type UpdateMappingColumnMapping1ApiResponse = unknown;
export type UpdateMappingColumnMapping1ApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
};
export type UpdateMappingColumnMappingApiResponse =
  /** status 200 OK */ MappingColumn;
export type UpdateMappingColumnMappingApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
  mappingColumn: MappingColumn;
};
export type GetMappingOtherScriptsMappingApiResponse =
  /** status 200 OK */ MappingOtherScriptsDto;
export type GetMappingOtherScriptsMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateMappingOtherScriptsMappingApiResponse = unknown;
export type UpdateMappingOtherScriptsMappingApiArg = {
  branchId: number;
  structureId: number;
  mappingOtherScriptsDto: MappingOtherScriptsDto;
};
export type GetMappingOverviewMappingApiResponse =
  /** status 200 OK */ MappingOverviewRead;
export type GetMappingOverviewMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateMappingOverviewMappingApiResponse =
  /** status 200 OK */ MappingOverviewRead;
export type UpdateMappingOverviewMappingApiArg = {
  branchId: number;
  structureId: number;
  mappingOverview: MappingOverview;
};
export type GetMappingPermissionsMappingApiResponse =
  /** status 200 OK */ MappingPermission[];
export type GetMappingPermissionsMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type SetMappingPermissionMappingApiResponse =
  /** status 200 OK */ MappingPermission;
export type SetMappingPermissionMappingApiArg = {
  branchId: number;
  structureId: number;
  mappingPermission: MappingPermission;
};
export type DeleteMappingPermissionMappingApiResponse = unknown;
export type DeleteMappingPermissionMappingApiArg = {
  branchId: number;
  structureId: number;
  userCode: string;
};
export type GetMappingSourcesMappingApiResponse =
  /** status 200 OK */ SourceItem[];
export type GetMappingSourcesMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type AddMappingSourceItemMappingApiResponse =
  /** status 200 OK */ SourceItem;
export type AddMappingSourceItemMappingApiArg = {
  branchId: number;
  structureId: number;
  sourceItem: SourceItem;
};
export type UpdateMappingSourceItemsMappingApiResponse =
  /** status 200 OK */ SourceItem[];
export type UpdateMappingSourceItemsMappingApiArg = {
  branchId: number;
  structureId: number;
  body: SourceItem[];
};
export type GetMappingSourcesDataMappingApiResponse =
  /** status 200 OK */ MappingSourcesData;
export type GetMappingSourcesDataMappingApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateMappingSourcesDataMappingApiResponse = unknown;
export type UpdateMappingSourcesDataMappingApiArg = {
  branchId: number;
  structureId: number;
  mappingSourcesData: MappingSourcesData;
};
export type DeleteMappingSourceItemMappingApiResponse = unknown;
export type DeleteMappingSourceItemMappingApiArg = {
  branchId: number;
  structureId: number;
  sourceItemId: string;
};
export type UpdateMappingSourceItemMappingApiResponse =
  /** status 200 OK */ SourceItem;
export type UpdateMappingSourceItemMappingApiArg = {
  branchId: number;
  structureId: number;
  sourceItemId: string;
  sourceItem: SourceItem;
};
export type RebaseBranchApiResponse =
  /** status 200 OK */ BranchRebaseResultDtoRead;
export type RebaseBranchApiArg = {
  branchId: number;
  branchRebaseRequestDto: BranchRebaseRequestDto;
};
export type GetStructuresStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetStructuresStructureV2ApiArg = {
  branchId: number;
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
  pageSize?: number;
  pageNumber?: number;
  /** DEFAULT for search by criteria is order by rank */
  sortBy?: SortBy;
  /** Append included structures to the result (History/Reference table) */
  appendIncluded?: boolean;
};
export type GenerateScriptsStructureV2ApiResponse =
  /** status 200 Async TASK information */ AsyncTaskExecutionDto;
export type GenerateScriptsStructureV2ApiArg = {
  branchId: number;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type BulkUnlockStructureV2ApiResponse = unknown;
export type BulkUnlockStructureV2ApiArg = {
  branchId: number;
  force?: boolean;
  id: number[];
};
export type BulkLockStructureV2ApiResponse = unknown;
export type BulkLockStructureV2ApiArg = {
  branchId: number;
  force?: boolean;
  id: number[];
};
export type SearchTableColumnsStructureV2ApiResponse =
  /** status 200 OK */ AutocompleteResultDto[];
export type SearchTableColumnsStructureV2ApiArg = {
  branchId: number;
  tableCode: string;
  searchText?: string;
  actualStructureId?: number;
};
export type GetFullTreeStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetFullTreeStructureV2ApiArg = {
  branchId: number;
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
};
export type GetChildrenStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetChildrenStructureV2ApiArg = {
  branchId: number;
  parentId: number;
  type?: StructureType[];
  search?: string;
  pageSize?: number;
  pageNumber?: number;
  maxLevel?: number;
};
export type CreateStructureStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type CreateStructureStructureV2ApiArg = {
  branchId: number;
  parentId: number;
  type: BasicStructureTypeEnum;
  name: string;
};
export type DeleteStructureStructureV2ApiResponse = unknown;
export type DeleteStructureStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type GetStructureMetadataStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type GetStructureMetadataStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type AsyncStructurePreviewStructureV2ApiResponse =
  /** status 200 Async TASK information */ AsyncTaskExecutionDto;
export type AsyncStructurePreviewStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  objectTypeId: number;
};
export type GetStructureHistoryStructureV2ApiResponse =
  /** status 200 OK */ PageWrapperHistoryWithDeploymentDto;
export type GetStructureHistoryStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  pageNumber?: number;
  pageSize?: number;
};
export type CreateStructureHistoryStructureV2ApiResponse =
  /** status 200 OK */ HistoryDto;
export type CreateStructureHistoryStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  description: string;
  fixImpacts?: boolean;
};
export type PrePushValidationStructureV2ApiResponse =
  /** status 200 OK */ PrePushValidationDto[];
export type PrePushValidationStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type CompareStructureHistoryStructureV2ApiResponse =
  /** status 200 OK */ DiffResultDto;
export type CompareStructureHistoryStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  leftHistoryId: number;
  rightHistoryId: number;
  includeUnchanged?: boolean;
};
export type GetStructureHistoryWithDeploymentStructureV2ApiResponse =
  /** status 200 OK */ HistoryWithDeploymentDto;
export type GetStructureHistoryWithDeploymentStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  versionNumber: number;
};
export type ReplaceStructureVersionStructureV2ApiResponse =
  /** status 200 OK */ HistoryDto;
export type ReplaceStructureVersionStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  versionNumber: number;
};
export type UnLockStructureStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type UnLockStructureStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type LockStructureStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type LockStructureStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type MoveNodeStructureV2ApiResponse = unknown;
export type MoveNodeStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  destinationStructureId: number;
};
export type GetNodeRelationsRelationApiResponse =
  /** status 200 OK */ RelationDto[];
export type GetNodeRelationsRelationApiArg = {
  branchId: number;
  structureId: number;
};
export type CreateRelationRelationApiResponse =
  /** status 200 OK */ RelationDto;
export type CreateRelationRelationApiArg = {
  branchId: number;
  structureId: number;
  relationCreateDto: RelationCreateDto;
};
export type DeleteRelationRelationApiResponse = unknown;
export type DeleteRelationRelationApiArg = {
  branchId: number;
  structureId: number;
  relationId: number;
};
export type PatchRelationRelationApiResponse = /** status 200 OK */ RelationDto;
export type PatchRelationRelationApiArg = {
  branchId: number;
  structureId: number;
  relationId: number;
  jsonPatch: JsonPatch;
};
export type UpdateRelationRelationApiResponse =
  /** status 200 OK */ RelationDto;
export type UpdateRelationRelationApiArg = {
  branchId: number;
  structureId: number;
  relationId: number;
  relationDto: RelationDto;
};
export type GetParentSystemStructureV2ApiResponse = /** status 200 OK */ System;
export type GetParentSystemStructureV2ApiArg = {
  branchId: number;
  structureId: number;
};
export type GetStructureTreeStructureV2ApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetStructureTreeStructureV2ApiArg = {
  branchId: number;
  structureId: number;
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
};
export type SearchNodesWithTypeStructureV2ApiResponse =
  /** status 200 OK */ AutocompleteResultDto[];
export type SearchNodesWithTypeStructureV2ApiArg = {
  branchId: number;
  structureType: StructureType;
  searchText: string;
  actualStructureId?: number;
};
export type GetStructureDetailTableApiResponse = /** status 200 OK */ Table;
export type GetStructureDetailTableApiArg = {
  structureId: number;
  branchId: number;
  versionNumber?: string;
};
export type UpdateTableTableApiResponse = unknown;
export type UpdateTableTableApiArg = {
  branchId: number;
  structureId: number;
  table: Table;
};
export type GetTableColumnsTableApiResponse =
  /** status 200 OK */ TableColumn[];
export type GetTableColumnsTableApiArg = {
  branchId: number;
  structureId: number;
};
export type AddTableColumnTableApiResponse = /** status 200 OK */ TableColumn;
export type AddTableColumnTableApiArg = {
  branchId: number;
  structureId: number;
  tableColumn: TableColumn;
};
export type UpdateTableColumnsTableApiResponse =
  /** status 200 OK */ TableColumn[];
export type UpdateTableColumnsTableApiArg = {
  branchId: number;
  structureId: number;
  body: TableColumn[];
};
export type DeleteTableColumnTableApiResponse = unknown;
export type DeleteTableColumnTableApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
};
export type UpdateTableColumnTableApiResponse =
  /** status 200 OK */ TableColumn;
export type UpdateTableColumnTableApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
  tableColumn: TableColumn;
};
export type GetTableConstraintsTableApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraintsTableApiArg = {
  branchId: number;
  structureId: number;
};
export type AddTableConstraintTableApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraintTableApiArg = {
  branchId: number;
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraintsTableApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraintsTableApiArg = {
  branchId: number;
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraintTableApiResponse = unknown;
export type DeleteTableConstraintTableApiArg = {
  branchId: number;
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraintTableApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraintTableApiArg = {
  branchId: number;
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetTableIndexesTableApiResponse = /** status 200 OK */ TableIndex[];
export type GetTableIndexesTableApiArg = {
  branchId: number;
  structureId: number;
};
export type AddTableIndexTableApiResponse = /** status 200 OK */ TableIndex;
export type AddTableIndexTableApiArg = {
  branchId: number;
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexesTableApiResponse =
  /** status 200 OK */ TableIndex[];
export type UpdateTableIndexesTableApiArg = {
  branchId: number;
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndexTableApiResponse = unknown;
export type DeleteTableIndexTableApiArg = {
  branchId: number;
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndexTableApiResponse = /** status 200 OK */ TableIndex;
export type UpdateTableIndexTableApiArg = {
  branchId: number;
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverviewTableApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type GetTableOverviewTableApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateTableOverviewTableApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type UpdateTableOverviewTableApiArg = {
  branchId: number;
  structureId: number;
  tableOverviewPartitioningStrategyTable: TableOverviewPartitioningStrategyTable;
};
export type DeleteTablePermissionTableApiResponse = unknown;
export type DeleteTablePermissionTableApiArg = {
  branchId: number;
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissionsTableApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissionsTableApiArg = {
  branchId: number;
  structureId: number;
};
export type SetTablePermissionTableApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermissionTableApiArg = {
  branchId: number;
  structureId: number;
  tablePermission: TablePermission;
};
export type GetTableScriptsTableApiResponse = /** status 200 OK */ TableScripts;
export type GetTableScriptsTableApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateTableScriptsTableApiResponse =
  /** status 200 OK */ TableScripts;
export type UpdateTableScriptsTableApiArg = {
  branchId: number;
  structureId: number;
  tableScripts: TableScripts;
};
export type GetStructureDetailViewApiResponse = /** status 200 OK */ View;
export type GetStructureDetailViewApiArg = {
  structureId: number;
  branchId: number;
  versionNumber?: string;
};
export type UpdateViewViewApiResponse = unknown;
export type UpdateViewViewApiArg = {
  branchId: number;
  structureId: number;
  view: View;
};
export type GetViewColumnsViewApiResponse = /** status 200 OK */ ViewColumn[];
export type GetViewColumnsViewApiArg = {
  branchId: number;
  structureId: number;
};
export type AddViewColumnViewApiResponse = /** status 200 OK */ ViewColumn;
export type AddViewColumnViewApiArg = {
  branchId: number;
  structureId: number;
  viewColumn: ViewColumn;
};
export type UpdateViewColumnsViewApiResponse =
  /** status 200 OK */ ViewColumn[];
export type UpdateViewColumnsViewApiArg = {
  branchId: number;
  structureId: number;
  body: ViewColumn[];
};
export type UpdateViewColumnView1ApiResponse = unknown;
export type UpdateViewColumnView1ApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
};
export type UpdateViewColumnViewApiResponse = /** status 200 OK */ ViewColumn;
export type UpdateViewColumnViewApiArg = {
  branchId: number;
  structureId: number;
  columnId: string;
  viewColumn: ViewColumn;
};
export type GetViewOverviewViewApiResponse =
  /** status 200 OK */ ViewOverviewRead;
export type GetViewOverviewViewApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateViewOverviewViewApiResponse =
  /** status 200 OK */ ViewOverviewRead;
export type UpdateViewOverviewViewApiArg = {
  branchId: number;
  structureId: number;
  viewOverview: ViewOverview;
};
export type GetViewPermissionsViewApiResponse =
  /** status 200 OK */ ViewPermission[];
export type GetViewPermissionsViewApiArg = {
  branchId: number;
  structureId: number;
};
export type SetViewPermissionViewApiResponse =
  /** status 200 OK */ ViewPermission;
export type SetViewPermissionViewApiArg = {
  branchId: number;
  structureId: number;
  viewPermission: ViewPermission;
};
export type DeleteViewPermissionViewApiResponse = unknown;
export type DeleteViewPermissionViewApiArg = {
  branchId: number;
  structureId: number;
  userCode: string;
};
export type GetViewSourcesViewApiResponse = /** status 200 OK */ SourceItem[];
export type GetViewSourcesViewApiArg = {
  branchId: number;
  structureId: number;
};
export type AddViewSourceItemViewApiResponse = /** status 200 OK */ SourceItem;
export type AddViewSourceItemViewApiArg = {
  branchId: number;
  structureId: number;
  sourceItem: SourceItem;
};
export type UpdateViewSourceItemsViewApiResponse =
  /** status 200 OK */ SourceItem[];
export type UpdateViewSourceItemsViewApiArg = {
  branchId: number;
  structureId: number;
  body: SourceItem[];
};
export type GetViewSourcesDataViewApiResponse =
  /** status 200 OK */ ViewSourcesData;
export type GetViewSourcesDataViewApiArg = {
  branchId: number;
  structureId: number;
};
export type UpdateViewSourcesDataViewApiResponse = unknown;
export type UpdateViewSourcesDataViewApiArg = {
  branchId: number;
  structureId: number;
  viewSourcesData: ViewSourcesData;
};
export type DeleteViewSourceItemViewApiResponse = unknown;
export type DeleteViewSourceItemViewApiArg = {
  branchId: number;
  structureId: number;
  sourceItemId: string;
};
export type UpdateViewSourceItemViewApiResponse =
  /** status 200 OK */ SourceItem;
export type UpdateViewSourceItemViewApiArg = {
  branchId: number;
  structureId: number;
  sourceItemId: string;
  sourceItem: SourceItem;
};
export type GetBranchChangesBetweenApiResponse =
  /** status 200 OK */ BranchStructureChangeDto[];
export type GetBranchChangesBetweenApiArg = {
  sourceBranchId: number;
  targetBranchId: number;
};
export type CreateMergeRequestApiResponse =
  /** status 200 OK */ MergeRequestDtoRead;
export type CreateMergeRequestApiArg = {
  sourceBranchId: number;
  targetBranchId: number;
  mergeRequestDto: MergeRequestDto;
};
export type GetMergeRequestsForBranchPairApiResponse =
  /** status 200 OK */ MergeRequestDtoRead[];
export type GetMergeRequestsForBranchPairApiArg = {
  sourceBranchId: number;
  targetBranchId: number;
};
export type GetEventsForTargetBranchApiResponse =
  /** status 200 OK */ MergeEventDtoRead[];
export type GetEventsForTargetBranchApiArg = {
  targetBranchId: number;
};
export type GetMergeRequestsForTargetBranchApiResponse =
  /** status 200 OK */ MergeRequestDtoRead[];
export type GetMergeRequestsForTargetBranchApiArg = {
  targetBranchId: number;
};
export type DeleteSystemReleaseApiResponse = unknown;
export type DeleteSystemReleaseApiArg = {
  dpId: number;
};
export type GetSystemReleaseApiResponse = /** status 200 OK */ ReleaseDtoRead;
export type GetSystemReleaseApiArg = {
  dpId: number;
};
export type UpdateSystemReleaseApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type UpdateSystemReleaseApiArg = {
  dpId: number;
  releaseDto: ReleaseDto;
};
export type GetReleaseEnvironmentsApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto[];
export type GetReleaseEnvironmentsApiArg = {
  dpId: number;
};
export type CreateReleaseEnvironmentApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type CreateReleaseEnvironmentApiArg = {
  dpId: number;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type DeleteReleaseEnvironmentApiResponse = unknown;
export type DeleteReleaseEnvironmentApiArg = {
  dpId: number;
  envCode: string;
};
export type UpdateReleaseEnvironmentApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type UpdateReleaseEnvironmentApiArg = {
  dpId: number;
  envCode: string;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type PushReleaseToGitApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type PushReleaseToGitApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type CreateReleaseScriptsApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type CreateReleaseScriptsApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type CreateDeploymentsApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type CreateDeploymentsApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type GetObjectSettingsApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetObjectSettingsApiArg = {
  dpId: number;
};
export type ChangeReleaseStatusApiResponse = unknown;
export type ChangeReleaseStatusApiArg = {
  dpId: number;
  newStatus: ReleaseStatusEnum;
};
export type GetReleaseStructuresApiResponse =
  /** status 200 OK */ PageWrapperStructureReleaseInfoDto;
export type GetReleaseStructuresApiArg = {
  dpId: number;
  page?: number;
  pageSize?: number;
};
export type AddStructureToReleaseApiResponse = unknown;
export type AddStructureToReleaseApiArg = {
  dpId: number;
  body: number[];
};
export type DeleteReleaseStructureApiResponse = unknown;
export type DeleteReleaseStructureApiArg = {
  dpId: number;
  structureId: number;
};
export type GetProvidersApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead[];
export type GetProvidersApiArg = void;
export type GetExpectationsApiResponse = /** status 200 OK */ ExpectationDto[];
export type GetExpectationsApiArg = {
  /** Provider code */
  providerCode?: string;
  /** When true returns only active expectations */
  active?: boolean;
};
export type ImportStructureCsvIntoNodeApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportStructureCsvIntoNodeApiArg = {
  branchId: number;
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  importAllColumns?: boolean;
  body: CsvImportRowDto[];
};
export type ImportStructureCsvIntoNodeCheckApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportStructureCsvIntoNodeCheckApiArg = {
  branchId: number;
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  importAllColumns?: boolean;
  body: CsvImportRowDto[];
};
export type ImportColumnsFromCsvApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportColumnsFromCsvApiArg = {
  branchId: number;
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  importAllColumns?: boolean;
  body: ImportColumn[];
};
export type ImportColumnsFromCsvCheckApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportColumnsFromCsvCheckApiArg = {
  branchId: number;
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  importAllColumns?: boolean;
  body: ImportColumn[];
};
export type ImportStructuresApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type ImportStructuresApiArg = {
  parentId?: number;
  branchId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type CheckJsonApiResponse = /** status 200 OK */ CheckResult;
export type CheckJsonApiArg = {
  parentId?: number;
  branchId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type GetImportResultApiResponse = /** status 200 OK */ Structure[];
export type GetImportResultApiArg = {
  taskId: number;
};
export type GetAllLovAcronymApiResponse =
  /** status 200 OK */ PageWrapperAcronymDtoRead;
export type GetAllLovAcronymApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type CreateLovAcronymApiArg = {
  acronymDto: AcronymDto;
};
export type DeleteLovAcronymApiResponse = unknown;
export type DeleteLovAcronymApiArg = {
  id: number;
};
export type GetLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type GetLovAcronymApiArg = {
  id: number;
};
export type UpdateLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type UpdateLovAcronymApiArg = {
  id: number;
  acronymDto: AcronymDto;
};
export type GetAllLovBusinessDomainApiResponse =
  /** status 200 OK */ PageWrapperBusinessDomainDtoRead;
export type GetAllLovBusinessDomainApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type CreateLovBusinessDomainApiArg = {
  businessDomainDto: BusinessDomainDto;
};
export type DeleteLovBusinessDomainApiResponse = unknown;
export type DeleteLovBusinessDomainApiArg = {
  id: number;
};
export type GetLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type GetLovBusinessDomainApiArg = {
  id: number;
};
export type UpdateLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type UpdateLovBusinessDomainApiArg = {
  id: number;
  businessDomainDto: BusinessDomainDto;
};
export type GetAllLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ PageWrapperCustomAttributeGroupDtoRead;
export type GetAllLovCustomAttributeGroupApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type CreateLovCustomAttributeGroupApiArg = {
  customAttributeGroupDto: CustomAttributeGroupDto;
};
export type DeleteLovCustomAttributeGroupApiResponse = unknown;
export type DeleteLovCustomAttributeGroupApiArg = {
  id: number;
};
export type GetLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type GetLovCustomAttributeGroupApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type UpdateLovCustomAttributeGroupApiArg = {
  id: number;
  customAttributeGroupDto: CustomAttributeGroupDto;
};
export type GetAllLovCustomAttributeLovApiResponse =
  /** status 200 OK */ PageWrapperCustomLovDtoRead;
export type GetAllLovCustomAttributeLovApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type CreateLovCustomAttributeLovApiArg = {
  customLovDto: CustomLovDto;
};
export type DownloadCustomLovsLovCustomAttributeLovApiResponse =
  /** status 200 OK */ string;
export type DownloadCustomLovsLovCustomAttributeLovApiArg = {
  search?: string;
};
export type DeleteLovCustomAttributeLovApiResponse = unknown;
export type DeleteLovCustomAttributeLovApiArg = {
  id: number;
};
export type GetLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type GetLovCustomAttributeLovApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type UpdateLovCustomAttributeLovApiArg = {
  id: number;
  customLovDto: CustomLovDto;
};
export type GetAllLovCustomAttributeApiResponse =
  /** status 200 OK */ PageWrapperCustomAttributeDtoRead;
export type GetAllLovCustomAttributeApiArg = {
  search?: string;
  structureType?: CustomAttributeStructureTypeEnum;
  stereotypeId?: number;
  stereotypeCode?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type CreateLovCustomAttributeApiArg = {
  customAttributeDto: CustomAttributeDto;
};
export type DeleteLovCustomAttributeApiResponse = unknown;
export type DeleteLovCustomAttributeApiArg = {
  id: number;
};
export type GetLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type GetLovCustomAttributeApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type UpdateLovCustomAttributeApiArg = {
  id: number;
  customAttributeDto: CustomAttributeDto;
};
export type GetAllLovDomainApiResponse =
  /** status 200 OK */ PageWrapperDomainV2DtoRead;
export type GetAllLovDomainApiArg = {
  search?: string;
  dataType?: DataTypeEnum;
  technologyId?: number;
  technologyCode?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type CreateLovDomainApiArg = {
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  domainV2Dto: DomainV2Dto;
};
export type DeleteLovDomainApiResponse = unknown;
export type DeleteLovDomainApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
};
export type GetLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type GetLovDomainApiArg = {
  id: number;
};
export type UpdateLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type UpdateLovDomainApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  domainV2Dto: DomainV2Dto;
};
export type ComputeImpactDomainChangeLovDomainApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactDomainChangeLovDomainApiArg = {
  /** Domain id */
  id: number;
  domainUpdateDto: DomainUpdateDto;
};
export type GetAllLovObjectTypeApiResponse =
  /** status 200 OK */ PageWrapperObjectSettingsDtoRead;
export type GetAllLovObjectTypeApiArg = {
  search?: string;
  structureType?: StructureType;
  defaultFlag?: boolean;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type CreateLovObjectTypeApiArg = {
  objectSettingsDto: ObjectSettingsDto;
};
export type DeleteLovObjectTypeApiResponse = unknown;
export type DeleteLovObjectTypeApiArg = {
  id: number;
};
export type GetLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type GetLovObjectTypeApiArg = {
  id: number;
};
export type UpdateLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type UpdateLovObjectTypeApiArg = {
  id: number;
  objectSettingsDto: ObjectSettingsDto;
};
export type GetAllLovStereotypeApiResponse =
  /** status 200 OK */ PageWrapperStereotypeV2DtoRead;
export type GetAllLovStereotypeApiArg = {
  search?: string;
  type?: StereotypeType[];
  category?: StereotypeCategory;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type CreateLovStereotypeApiArg = {
  stereotypeV2Dto: StereotypeV2Dto;
};
export type DeleteLovStereotypeApiResponse = unknown;
export type DeleteLovStereotypeApiArg = {
  id: number;
};
export type GetLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type GetLovStereotypeApiArg = {
  id: number;
};
export type UpdateLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type UpdateLovStereotypeApiArg = {
  id: number;
  stereotypeV2Dto: StereotypeV2Dto;
};
export type GetAllLovTechnicalColumnApiResponse =
  /** status 200 OK */ PageWrapperTechnicalColumnV2DtoRead;
export type GetAllLovTechnicalColumnApiArg = {
  search?: string;
  stereotypeId?: number;
  stereotypeCode?: string;
  updatedBy?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type CreateLovTechnicalColumnApiArg = {
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type DeleteLovTechnicalColumnApiResponse = unknown;
export type DeleteLovTechnicalColumnApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
};
export type GetLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type GetLovTechnicalColumnApiArg = {
  id: number;
};
export type UpdateLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type UpdateLovTechnicalColumnApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type ComputeImpactTcChangeLovTechnicalColumnApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactTcChangeLovTechnicalColumnApiArg = {
  /** Technical column id */
  id: number;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type GetAllLovTechnologyApiResponse =
  /** status 200 OK */ PageWrapperTechnologyV2DtoRead;
export type GetAllLovTechnologyApiArg = {
  type?: TechnologyType;
  pageNumber?: number;
  pageSize?: number;
};
export type GetMergeRequestApiResponse =
  /** status 200 OK */ MergeRequestDtoRead;
export type GetMergeRequestApiArg = {
  mergeRequestId: number;
};
export type GetApprovalsApiResponse =
  /** status 200 OK */ MergeRequestApprovalDtoRead[];
export type GetApprovalsApiArg = {
  mergeRequestId: number;
};
export type SaveResolutionApiResponse =
  /** status 200 OK */ MergeRequestConflictResolutionDtoRead;
export type SaveResolutionApiArg = {
  mergeRequestId: number;
  structureId: string;
  fieldPath: string;
  sourceValue?: string;
  targetValue?: string;
  selectedValue?: string;
  resolution: string;
};
export type GetResolutionsApiResponse =
  /** status 200 OK */ MergeRequestConflictResolutionDtoRead[];
export type GetResolutionsApiArg = {
  mergeRequestId: number;
};
export type DecideApiResponse =
  /** status 200 OK */ MergeRequestApprovalDtoRead;
export type DecideApiArg = {
  mergeRequestId: number;
  decision: MergeRequestDecisionEnum;
  comment?: string;
};
export type ExecuteMergeApiResponse = /** status 200 OK */ MergeEventDtoRead;
export type ExecuteMergeApiArg = {
  mergeRequestId: number;
};
export type GetEventsForMergeRequestApiResponse =
  /** status 200 OK */ MergeEventDtoRead[];
export type GetEventsForMergeRequestApiArg = {
  mergeRequestId: number;
};
export type RecalculateDiffApiResponse =
  /** status 200 OK */ MergeRequestDtoRead;
export type RecalculateDiffApiArg = {
  mergeRequestId: number;
};
export type MarkStaleApiResponse = /** status 200 OK */ MergeRequestDtoRead;
export type MarkStaleApiArg = {
  mergeRequestId: number;
  staleReason: MergeRequestStaleReasonEnum;
};
export type UpdateMergeRequestStatusApiResponse =
  /** status 200 OK */ MergeRequestDtoRead;
export type UpdateMergeRequestStatusApiArg = {
  mergeRequestId: number;
  status: MergeRequestStatusEnum;
};
export type GetSecretsApiResponse = /** status 200 OK */ SecretDtoRead[];
export type GetSecretsApiArg = {
  type?: SecretType;
};
export type CreateSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type CreateSecretApiArg = {
  secretDto: SecretDtoWrite;
};
export type DeleteSecretApiResponse = unknown;
export type DeleteSecretApiArg = {
  secretId: number;
};
export type GetSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type GetSecretApiArg = {
  secretId: number;
};
export type UpdateSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type UpdateSecretApiArg = {
  secretId: number;
  secretDto: SecretDtoWrite;
};
export type CreateSystemApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type CreateSystemApiArg = {
  system: System;
};
export type GetSystemsApiResponse =
  /** status 200 OK */ StructureReferenceInfoDto[];
export type GetSystemsApiArg = void;
export type GetDeletedStructuresApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetDeletedStructuresApiArg = {
  search?: string;
  pageSize?: number;
  pageNumber?: number;
};
export type UndeleteStructureApiResponse = unknown;
export type UndeleteStructureApiArg = {
  structureId: number;
  newParentId?: number;
};
export type GetStructureAclApiResponse = /** status 200 OK */ AclEntryDtoRead[];
export type GetStructureAclApiArg = {
  structureId: number;
};
export type CreateStructureAclApiResponse =
  /** status 200 OK */ AclEntryDtoRead;
export type CreateStructureAclApiArg = {
  structureId: number;
  aclEntryDto: AclEntryDto;
};
export type GetEffectiveAclApiResponse = /** status 200 OK */ AclEntryDtoRead[];
export type GetEffectiveAclApiArg = {
  structureId: number;
};
export type EvaluatePermissionsApiResponse =
  /** status 200 OK */ PermissionEvaluationDtoRead;
export type EvaluatePermissionsApiArg = {
  /** structure id */
  structureId: number;
  /** for specific user */
  forUserId?: number;
  /** for specific group */
  groupName?: string;
};
export type DeleteStructureAclApiResponse = unknown;
export type DeleteStructureAclApiArg = {
  structureId: number;
  aclId: number;
};
export type UpdateStructureAclApiResponse = unknown;
export type UpdateStructureAclApiArg = {
  structureId: number;
  aclId: number;
  aclEntryDto: AclEntryDto;
};
export type CountApiResponse = /** status 200 OK */ {
  [key: string]: number;
};
export type CountApiArg = {
  structureId: number;
};
export type GetStructureHistoryByIdApiResponse =
  /** status 200 OK */ HistoryWithDeploymentDto;
export type GetStructureHistoryByIdApiArg = {
  structureId: number;
  versionId: number;
};
export type GetBranchesApiResponse =
  /** status 200 OK */ PageWrapperBranchDtoRead;
export type GetBranchesApiArg = {
  systemId: number;
  /** Search string for branch name contains ignore case */
  search?: string;
  /** List of branch statuses to filter by, default is not DELETED, ARCHIVED */
  status?: BranchStatusEnum[];
  protectedBranch?: boolean;
  selfApprovalAllowed?: boolean;
  sourceBranchId?: number;
  sourceDeploymentPackageId?: number;
  /** Page number from 1 */
  pageNumber?: number;
  /** Page size */
  pageSize?: number;
};
export type CreateBranchApiResponse = /** status 200 OK */ BranchDtoRead;
export type CreateBranchApiArg = {
  systemId: number;
  branchDto: BranchDto;
};
export type GetDeploymentPackagesApiResponse =
  /** status 200 OK */ PageWrapperReleaseDtoRead;
export type GetDeploymentPackagesApiArg = {
  systemId: number;
  status?: ReleaseStatusEnum;
  pageNumber?: number;
  pageSize?: number;
};
export type CreateDeploymentPackageApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type CreateDeploymentPackageApiArg = {
  systemId: number;
  releaseDto: ReleaseDto;
};
export type GetEnvGitBranchesApiResponse = /** status 200 OK */ string[];
export type GetEnvGitBranchesApiArg = {
  systemId: number;
  envCode: string;
};
export type GetMergeRequestsInSystemApiResponse =
  /** status 200 OK */ PageWrapperMergeRequestDtoRead;
export type GetMergeRequestsInSystemApiArg = {
  systemId: number;
  sourceBranchId?: number;
  targetBranchId?: number;
  status?: MergeRequestStatusEnum[];
  authorId?: number;
  /** Page number for pagination, starting from 1 */
  page?: number;
  /** Page size for pagination */
  pageSize?: number;
};
export type GetStructureDetailTableHistoryApiResponse =
  /** status 200 OK */ HistoryTable;
export type GetStructureDetailTableHistoryApiArg = {
  structureId: number;
  versionNumber?: string;
};
export type UpdateTableTableHistoryApiResponse = unknown;
export type UpdateTableTableHistoryApiArg = {
  structureId: number;
  historyTable: HistoryTable;
};
export type GetTableColumnsTableHistoryApiResponse =
  /** status 200 OK */ TableColumn[];
export type GetTableColumnsTableHistoryApiArg = {
  structureId: number;
};
export type GetTableConstraintsTableHistoryApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraintsTableHistoryApiArg = {
  structureId: number;
};
export type AddTableConstraintTableHistoryApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraintTableHistoryApiArg = {
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraintsTableHistoryApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraintsTableHistoryApiArg = {
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraintTableHistoryApiResponse = unknown;
export type DeleteTableConstraintTableHistoryApiArg = {
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraintTableHistoryApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraintTableHistoryApiArg = {
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetTableIndexesTableHistoryApiResponse =
  /** status 200 OK */ TableIndex[];
export type GetTableIndexesTableHistoryApiArg = {
  structureId: number;
};
export type AddTableIndexTableHistoryApiResponse =
  /** status 200 OK */ TableIndex;
export type AddTableIndexTableHistoryApiArg = {
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexesTableHistoryApiResponse =
  /** status 200 OK */ TableIndex[];
export type UpdateTableIndexesTableHistoryApiArg = {
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndexTableHistoryApiResponse = unknown;
export type DeleteTableIndexTableHistoryApiArg = {
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndexTableHistoryApiResponse =
  /** status 200 OK */ TableIndex;
export type UpdateTableIndexTableHistoryApiArg = {
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverviewTableHistoryApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyHistoryTableRead;
export type GetTableOverviewTableHistoryApiArg = {
  structureId: number;
};
export type UpdateTableOverviewTableHistoryApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyHistoryTableRead;
export type UpdateTableOverviewTableHistoryApiArg = {
  structureId: number;
  tableOverviewPartitioningStrategyHistoryTable: TableOverviewPartitioningStrategyHistoryTable;
};
export type DeleteTablePermissionTableHistoryApiResponse = unknown;
export type DeleteTablePermissionTableHistoryApiArg = {
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissionsTableHistoryApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissionsTableHistoryApiArg = {
  structureId: number;
};
export type SetTablePermissionTableHistoryApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermissionTableHistoryApiArg = {
  structureId: number;
  tablePermission: TablePermission;
};
export type GetTableScriptsTableHistoryApiResponse =
  /** status 200 OK */ TableScripts;
export type GetTableScriptsTableHistoryApiArg = {
  structureId: number;
};
export type UpdateTableScriptsTableHistoryApiResponse =
  /** status 200 OK */ TableScripts;
export type UpdateTableScriptsTableHistoryApiArg = {
  structureId: number;
  tableScripts: TableScripts;
};
export type GetStructureDetailTableReferenceApiResponse =
  /** status 200 OK */ ReferenceTable;
export type GetStructureDetailTableReferenceApiArg = {
  structureId: number;
  versionNumber?: string;
};
export type UpdateTableTableReferenceApiResponse = unknown;
export type UpdateTableTableReferenceApiArg = {
  structureId: number;
  referenceTable: ReferenceTable;
};
export type GetTableColumnsTableReferenceApiResponse =
  /** status 200 OK */ TableColumn[];
export type GetTableColumnsTableReferenceApiArg = {
  structureId: number;
};
export type GetTableConstraintsTableReferenceApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraintsTableReferenceApiArg = {
  structureId: number;
};
export type AddTableConstraintTableReferenceApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraintTableReferenceApiArg = {
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraintsTableReferenceApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraintsTableReferenceApiArg = {
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraintTableReferenceApiResponse = unknown;
export type DeleteTableConstraintTableReferenceApiArg = {
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraintTableReferenceApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraintTableReferenceApiArg = {
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetTableIndexesTableReferenceApiResponse =
  /** status 200 OK */ TableIndex[];
export type GetTableIndexesTableReferenceApiArg = {
  structureId: number;
};
export type AddTableIndexTableReferenceApiResponse =
  /** status 200 OK */ TableIndex;
export type AddTableIndexTableReferenceApiArg = {
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexesTableReferenceApiResponse =
  /** status 200 OK */ TableIndex[];
export type UpdateTableIndexesTableReferenceApiArg = {
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndexTableReferenceApiResponse = unknown;
export type DeleteTableIndexTableReferenceApiArg = {
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndexTableReferenceApiResponse =
  /** status 200 OK */ TableIndex;
export type UpdateTableIndexTableReferenceApiArg = {
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverviewTableReferenceApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type GetTableOverviewTableReferenceApiArg = {
  structureId: number;
};
export type UpdateTableOverviewTableReferenceApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type UpdateTableOverviewTableReferenceApiArg = {
  structureId: number;
  tableOverviewPartitioningStrategyTable: TableOverviewPartitioningStrategyTable;
};
export type DeleteTablePermissionTableReferenceApiResponse = unknown;
export type DeleteTablePermissionTableReferenceApiArg = {
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissionsTableReferenceApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissionsTableReferenceApiArg = {
  structureId: number;
};
export type SetTablePermissionTableReferenceApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermissionTableReferenceApiArg = {
  structureId: number;
  tablePermission: TablePermission;
};
export type GetTableScriptsTableReferenceApiResponse =
  /** status 200 OK */ TableScripts;
export type GetTableScriptsTableReferenceApiArg = {
  structureId: number;
};
export type UpdateTableScriptsTableReferenceApiResponse =
  /** status 200 OK */ TableScripts;
export type UpdateTableScriptsTableReferenceApiArg = {
  structureId: number;
  tableScripts: TableScripts;
};
export type GetAllTemplatesApiResponse =
  /** status 200 OK */ TemplateListDtoRead[];
export type GetAllTemplatesApiArg = {
  /** Technology id */
  technologyId?: number;
  /** Stereotype id */
  stereotypeId?: number;
};
export type CreateTemplateApiResponse =
  /** status 201 Created */ TemplateDtoRead;
export type CreateTemplateApiArg = {
  templateDto: TemplateDto;
};
export type DeleteTemplateApiResponse = unknown;
export type DeleteTemplateApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateApiResponse = /** status 200 OK */ TemplateDtoRead;
export type GetTemplateApiArg = {
  /** Template id */
  id: number;
};
export type UpdateTemplateApiResponse = /** status 200 OK */ TemplateDtoRead;
export type UpdateTemplateApiArg = {
  /** Template id */
  id: number;
  templateDto: TemplateDto;
};
export type GetTemplateHistoryApiResponse =
  /** status 200 OK */ TemplateListDtoRead[];
export type GetTemplateHistoryApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateHistoryDetailApiResponse =
  /** status 200 OK */ TemplateDtoRead;
export type GetTemplateHistoryDetailApiArg = {
  /** Template id */
  id: number;
  /** Template version */
  version: number;
};
export type PostTemplateLockApiResponse = unknown;
export type PostTemplateLockApiArg = {
  /** Template id */
  templateId: number;
};
export type PostTemplatePushApiResponse = unknown;
export type PostTemplatePushApiArg = {
  /** Template id */
  templateId: number;
  /** Unlock after push */
  unlock?: boolean;
};
export type PostTemplateUnlockApiResponse = unknown;
export type PostTemplateUnlockApiArg = {
  /** Template id */
  templateId: number;
};
export type GetTenantApiResponse = /** status 200 OK */ TenantDtoRead;
export type GetTenantApiArg = void;
export type UpdateTenantApiResponse = /** status 200 OK */ TenantDtoRead;
export type UpdateTenantApiArg = {
  tenantDto: TenantDto;
};
export type GetUsersApiResponse = /** status 200 OK */ PageWrapperUserDtoRead;
export type GetUsersApiArg = {
  search?: string;
  type?: UserType;
  pageSize?: number;
  pageNumber?: number;
};
export type AddUserApiResponse = /** status 200 OK */ UserDtoRead;
export type AddUserApiArg = {
  password?: string;
  userDto: UserDto;
};
export type GetApiUsersApiResponse = /** status 200 OK */ ApiUserDtoRead[];
export type GetApiUsersApiArg = void;
export type AddApiUserApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type AddApiUserApiArg = {
  apiUserDto: ApiUserDto;
};
export type DeleteApiUserApiResponse = unknown;
export type DeleteApiUserApiArg = {
  clientId: string;
};
export type ApiUserUpdateApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type ApiUserUpdateApiArg = {
  clientId: string;
  apiUserDto: ApiUserDto;
};
export type ApiUserResetSecretApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type ApiUserResetSecretApiArg = {
  clientId: string;
};
export type GetSessionContextApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type GetSessionContextApiArg = void;
export type UpdateSessionContextApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type UpdateSessionContextApiArg = {
  sessionContextDto: SessionContextDto;
};
export type GetGroupsApiResponse = /** status 200 OK */ GroupDtoRead[];
export type GetGroupsApiArg = {
  pageSize?: number;
  pageNumber?: number;
};
export type CreateGroupApiResponse = /** status 200 OK */ GroupDtoRead;
export type CreateGroupApiArg = {
  groupDto: GroupDto;
};
export type DeleteGroupApiResponse = unknown;
export type DeleteGroupApiArg = {
  groupId: string;
};
export type UpdateGroupApiResponse = unknown;
export type UpdateGroupApiArg = {
  groupId: string;
  groupDto: GroupDto;
};
export type GetRolesForGroupApiResponse = /** status 200 OK */ RoleEnum[];
export type GetRolesForGroupApiArg = {
  groupId: string;
};
export type SetRolesForGroupApiResponse = unknown;
export type SetRolesForGroupApiArg = {
  groupId: string;
  body: ManagedRole[];
};
export type RemoveUserFromGroupApiResponse = unknown;
export type RemoveUserFromGroupApiArg = {
  groupId: string;
  userId: number[];
};
export type GetUsersInGroupApiResponse =
  /** status 200 OK */ PageWrapperUserDtoRead;
export type GetUsersInGroupApiArg = {
  groupId: string;
  pageSize?: number;
  pageNumber?: number;
};
export type AddUserToGroupApiResponse = unknown;
export type AddUserToGroupApiArg = {
  groupId: string;
  userId: number[];
};
export type GetUserListApiResponse = /** status 200 OK */ UserComboDto[];
export type GetUserListApiArg = void;
export type DeleteUserApiResponse = unknown;
export type DeleteUserApiArg = {
  userId: number;
};
export type GetUserApiResponse = /** status 200 OK */ UserDtoRead;
export type GetUserApiArg = {
  userId: number;
};
export type EditUserApiResponse = /** status 200 OK */ UserDtoRead;
export type EditUserApiArg = {
  userId: number;
  userDto: UserDto;
};
export type GetUserGroupsApiResponse = /** status 200 OK */ GroupDtoRead[];
export type GetUserGroupsApiArg = {
  userId: number;
};
export type UnLockUserApiResponse = unknown;
export type UnLockUserApiArg = {
  userId: number;
};
export type LockUserApiResponse = unknown;
export type LockUserApiArg = {
  userId: number;
};
export type ResetPasswordApiResponse = unknown;
export type ResetPasswordApiArg = {
  userId: number;
};
export type GetRolesForUserApiResponse = /** status 200 OK */ RoleEnum[];
export type GetRolesForUserApiArg = {
  userId: number;
};
export type SetRolesForUserApiResponse = unknown;
export type SetRolesForUserApiArg = {
  userId: number;
  body: ManagedRole[];
};
export type ExpectationProviderDto = {
  code: string;
  description?: string;
  name: string;
  providerVersion: string;
};
export type ExpectationProviderDtoRead = {
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  providerVersion: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DataTypeEnum = "STRING" | "NUMBER" | "BOOLEAN" | "DATETIME";
export type ExpectationGroupCode =
  | "RANGE"
  | "SETS_AND_LISTS"
  | "PATTERNS"
  | "BASIC";
export type ExpectationAdminDto = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  name: string;
  providerId: number;
  templateText: string;
};
export type ExpectationAdminDtoRead = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  id?: number;
  name: string;
  providerCode?: string;
  providerId: number;
  templateText: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type UserInfoDto = {
  id: number;
};
export type UserInfoDtoRead = {
  email?: string;
  fullName?: string;
  id: number;
  loginName?: string;
};
export type LovReference = {
  code?: string;
  id: number;
};
export type LovReferenceRead = {
  code?: string;
  id: number;
  name?: string;
};
export type BranchStatusEnum = "ACTIVE" | "LOCKED" | "ARCHIVED" | "DELETED";
export type StructureType =
  | "ROOT"
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "CONSTANT_DOMAIN"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type StructureReferenceInfoDto = {
  code?: string;
  fullPath?: string;
  id?: number;
  name?: string;
  type?: StructureType;
  uuid?: string;
};
export type BranchDto = {
  description?: string;
  mergeLockUser?: UserInfoDto;
  name?: string;
  protectedBranch?: boolean;
  requireExplicitMergeAction?: boolean;
  requiredApprovals?: number;
  restrictToExplicitPermissions?: boolean;
  selfApprovalAllowed?: boolean;
  sourceBranch?: LovReference;
  sourceReleaseId?: number;
  status?: BranchStatusEnum;
  system?: StructureReferenceInfoDto;
};
export type BranchDtoRead = {
  createdAt?: string;
  createdBy?: string;
  description?: string;
  id?: number;
  mergeLockTime?: string;
  mergeLockUser?: UserInfoDtoRead;
  name?: string;
  protectedBranch?: boolean;
  requireExplicitMergeAction?: boolean;
  requiredApprovals?: number;
  restrictToExplicitPermissions?: boolean;
  selfApprovalAllowed?: boolean;
  sourceBranch?: LovReferenceRead;
  sourceReleaseId?: number;
  status?: BranchStatusEnum;
  system?: StructureReferenceInfoDto;
  updatedAt?: string;
  updatedBy?: string;
};
export type ChangeType =
  | "ADDED"
  | "REMOVED"
  | "MODIFIED"
  | "UNCHANGED"
  | "CONFLICT"
  | "MOVED";
export type DiffChangeDto = {
  baseValue?: any;
  changeType?: ChangeType;
  fieldPath?: string;
  newValue?: any;
  oldValue?: any;
};
export type DiffResultDto = {
  changes?: DiffChangeDto[];
  leftHistoryId?: number;
  rightHistoryId?: number;
  structureId?: number;
};
export type BranchStructureChangeDto = {
  ancestorVersion?: number;
  branchId?: number;
  changeType?: ChangeType;
  code?: string;
  comparedBranchId?: number;
  comparedVersion?: number;
  conflicts?: DiffChangeDto[];
  currentVersion?: number;
  diff?: DiffResultDto;
  name?: string;
  structureId?: number;
};
export type MergeRequestStatusEnum =
  | "DRAFT"
  | "OPEN"
  | "CHANGES_REQUESTED"
  | "APPROVED"
  | "REJECTED"
  | "MERGED"
  | "CLOSED"
  | "STALE";
export type BranchRebaseBlockingMergeRequestDto = {
  id?: number;
  sourceBranchId?: number;
  status?: MergeRequestStatusEnum;
  targetBranchId?: number;
  title?: string;
};
export type Status =
  | "logical_in_progress"
  | "logical_completed"
  | "physical_in_progress"
  | "physical_completed"
  | "frozen";
export type BranchCherryPickElementDto = {
  code?: string;
  conflicts?: DiffChangeDto[];
  message?: string;
  missingDependencies?: number[];
  name?: string;
  sourceHistoryId?: number;
  sourceParentStructureId?: number;
  status?: Status;
  structureId?: number;
  targetHistoryId?: number;
  targetParentStructureId?: number;
};
export type BranchCherryPickResultDto = {
  blockingMergeRequests?: BranchRebaseBlockingMergeRequestDto[];
  elements?: BranchCherryPickElementDto[];
  message?: string;
  status?: Status;
};
export type BranchCherryPickRequestDto = {
  conflictResolutions?: {
    [key: string]: {
      [key: string]: any;
    };
  };
  continueWithMissingDependencies?: boolean;
  expectedSourceHistoryIds?: {
    [key: string]: number;
  };
  expectedSourceParentIds?: {
    [key: string]: number;
  };
  expectedTargetHistoryIds?: {
    [key: string]: number;
  };
  expectedTargetParentIds?: {
    [key: string]: number;
  };
  sourceBranchId: number;
  structureIds: number[];
};
export type ReleaseStatusEnum = "OPEN" | "CANCEL" | "COMPLETED";
export type ReleaseDto = {
  branch: LovReference;
  description?: string;
  name: string;
  responsibleUser?: UserInfoDto;
  status?: ReleaseStatusEnum;
};
export type ReleaseDtoRead = {
  branch: LovReferenceRead;
  canEditWholeContent?: boolean;
  canReadWholeContent?: boolean;
  description?: string;
  id?: number;
  name: string;
  responsibleUser?: UserInfoDtoRead;
  status?: ReleaseStatusEnum;
};
export type TableConstraintColumn = {
  code?: string;
  foreignColumnCode?: string;
  foreignColumnUuid?: string;
  name?: string;
  order?: number;
  uuid?: string;
};
export type ReferenceObjectInfo = {
  code?: string;
  id: number;
  uuid?: string;
};
export type ReferenceObjectInfoRead = {
  code?: string;
  id: number;
  name?: string;
  uuid?: string;
};
export type Cardinality =
  | "ONE"
  | "MANY"
  | "ONE_ONLY"
  | "ONE_OR_MANY"
  | "ZERO_OR_ONE"
  | "ZERO_OR_MANY";
export type ForeignKey = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  name?: string;
  source?: ReferenceObjectInfo;
  sourceCardinality?: Cardinality;
  target?: ReferenceObjectInfo;
  targetCardinality?: Cardinality;
  uuid?: string;
};
export type ForeignKeyRead = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  name?: string;
  source?: ReferenceObjectInfoRead;
  sourceCardinality?: Cardinality;
  target?: ReferenceObjectInfoRead;
  targetCardinality?: Cardinality;
  uuid?: string;
};
export type CustomAttribute = {
  id?: string;
  name?: string;
  source?: string;
  value?: any;
  version?: string;
};
export type TableColumnDomain = {
  code?: string;
  id?: number;
  name?: string;
};
export type DefinitionKind =
  | "odcs_library"
  | "sql"
  | "expectation"
  | "free_text";
export type Dimension =
  | "accuracy"
  | "completeness"
  | "conformity"
  | "consistency"
  | "coverage"
  | "timeliness"
  | "uniqueness";
export type ExpectationDefinitionRef = {
  code?: string;
  providerCode?: string;
};
export type Kwargs = any;
export type Representation = any;
export type Expectation = {
  definition?: ExpectationDefinitionRef;
  kwargs?: Kwargs;
  representation?: Representation;
};
export type Arguments = any;
export type OdcsLibrary = {
  arguments?: Arguments;
  metric?: string;
  operator?: string;
};
export type Severity = "error" | "warning" | "info";
export type DqRuleSql = {
  operator?: any;
  query?: string;
};
export type DqRule = {
  definitionKind?: DefinitionKind;
  description?: string;
  dimension?: Dimension;
  expectation?: Expectation;
  freeText?: string;
  library?: OdcsLibrary;
  name?: string;
  severity?: Severity;
  sql?: DqRuleSql;
  uuid?: string;
};
export type TableColumnStereotype = {
  code?: string;
  id?: number;
  name?: string;
};
export type TableColumn = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domain?: TableColumnDomain;
  foreignKey?: boolean;
  g_hasTemplate?: boolean;
  g_isTextValue?: boolean;
  g_template?: string;
  ghasTemplate?: boolean;
  gisTextValue?: boolean;
  gtemplate?: string;
  historyColumn?: boolean;
  id?: number;
  mandatory?: boolean;
  name?: string;
  notNull?: boolean;
  notNullFlag?: boolean;
  odcsDqRules?: DqRule[];
  order?: number;
  primaryKey?: boolean;
  stereotype?: TableColumnStereotype;
  stereotypeColumn?: boolean;
  technicalColumnId?: number;
  uuid?: string;
  virtualColumnScript?: string;
};
export type ConstraintType =
  | "primary_key"
  | "foreign_key"
  | "custom"
  | "unique"
  | "check";
export type TableConstraint = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  constraintType?: ConstraintType;
  description?: string;
  enabled?: boolean;
  expression?: string;
  foreignKeyTableId?: number;
  foreignKeyTableUuid?: string;
  g_foreignKeyTableCode?: string;
  g_foreignKeyTableOwner?: string;
  gforeignKeyTableCode?: string;
  gforeignKeyTableOwner?: string;
  id?: number;
  name?: string;
  order?: number;
  physicalOptions?: string;
  script?: string;
  sourceCardinality?: Cardinality;
  targetCardinality?: Cardinality;
};
export type EntityType =
  | "aggregate"
  | "auxiliary"
  | "composition"
  | "fundamental"
  | "metadata"
  | "relation"
  | "snapshot"
  | "specialisation"
  | "transaction";
export type SortType = "ASC" | "DESC";
export type TableIndexColumn = {
  code?: string;
  order?: number;
  sortType?: SortType;
  uuid?: string;
};
export type TableIndex = {
  code?: string;
  columns?: TableIndexColumn[];
  comment?: string;
  description?: string;
  id?: number;
  isUnique?: boolean;
  name?: string;
  order?: number;
  physicalOptions?: string;
};
export type NonSyncFieldTable =
  | "uuid"
  | "name"
  | "code"
  | "comment"
  | "description"
  | "stereotypeId"
  | "stereotypeCode"
  | "subStereotypeId"
  | "hasHistoryTable"
  | "hasReferenceTable"
  | "businessDomainId"
  | "businessDomainName"
  | "entityType"
  | "status"
  | "responsibleAnalystId"
  | "responsibleAnalystName"
  | "responsiblePersonId"
  | "responsiblePersonName"
  | "retentionStrategy"
  | "retentionStrategyFullHistoryValue"
  | "retentionStrategyFullHistoryUnit"
  | "retentionStrategyEomValue"
  | "retentionStrategyEomUnit"
  | "columns"
  | "columnsLastId"
  | "indexes"
  | "indexesLastId"
  | "constraints"
  | "constraintsLastId"
  | "historyTable"
  | "referenceTable"
  | "script"
  | "preTableScript"
  | "postTableScript"
  | "partitioningStrategy"
  | "partitioningColumnId"
  | "partitioningColumnCode"
  | "sequenceCode"
  | "sequenceColumnCode"
  | "ownerId"
  | "ownerName"
  | "objectSettings"
  | "customAttributes";
export type TablePermissionEnum =
  | "ALTER"
  | "SELECT"
  | "DELETE"
  | "UPDATE"
  | "INSERT"
  | "REFERENCE"
  | "SEQUENCE";
export type SystemUser = {
  code?: string;
  comment?: string;
  description?: string;
  id?: number;
  name?: string;
};
export type TablePermission = {
  id?: number;
  order?: number;
  permissions?: TablePermissionEnum[];
  user?: SystemUser;
};
export type ObjectSettings = {
  code?: string;
  id?: number;
  name?: string;
};
export type Parent = {
  code?: string;
  name?: string;
};
export type PartitioningStrategyHistoryTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective"
  | "source_system_and_valid_to";
export type RetentionStrategy =
  | "infinite"
  | "delete_after"
  | "move_after"
  | "keep_full_history"
  | "keep_full_history_and_eom";
export type RetentionTimeUnit = "day" | "month" | "year";
export type HistoryTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isHistoryTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisHistoryTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type PartitioningStrategyTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective";
export type ReferenceTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isReferenceTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisReferenceTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type Table = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  historyTable?: HistoryTable;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  odcsDqRules?: DqRule[];
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  referenceTable?: ReferenceTable;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type StructureDtoTable = {
  code?: string;
  data?: Table;
  id?: number;
  lastUpdatedAt?: string;
  name?: string;
  parentId?: number;
  type?: StructureType;
  uuid?: string;
  version?: number;
};
export type DiagramDataResponse = {
  foreignKeys?: ForeignKey[];
  notFoundTableIds?: number[];
  tables?: StructureDtoTable[];
};
export type DiagramDataResponseRead = {
  foreignKeys?: ForeignKeyRead[];
  notFoundTableIds?: number[];
  tables?: StructureDtoTable[];
};
export type Inspector = any;
export type Point = {
  x?: number;
  y?: number;
};
export type LinkData = {
  code?: string;
  from?: number;
  fromPort?: string;
  key?: number;
  linksColor?: string;
  points?: Point[];
  text?: string;
  to?: number;
  toPort?: string;
};
export type ModelData = any;
export type NodeData = {
  category?: string;
  code?: string;
  columns?: TableColumn[];
  key?: number;
  loc?: string;
  nodeBodyColor?: string;
  nodeHeaderColor?: string;
  tableColumnsVisibility?: boolean;
  text?: string;
  version?: number;
};
export type DisplayOptions = {
  columnsCode?: boolean;
  columnsName?: boolean;
  comments?: boolean;
  description?: boolean;
  hasName?: boolean;
  pkColumnsCode?: boolean;
  pkColumnsName?: boolean;
  tableCode?: boolean;
  tableColumns?: boolean;
  tableName?: boolean;
};
export type LineColors = {
  horizontal?: string;
  intervalHorizontal?: string;
  intervalVertical?: string;
  vertical?: string;
};
export type Grid = {
  cellSize?: number;
  isVisible?: boolean;
  lineColors?: LineColors;
};
export type Links = {
  color?: string;
  routingType?: string;
};
export type Body = {
  color?: string;
};
export type Header = {
  color?: string;
};
export type Node = {
  body?: Body;
  header?: Header;
};
export type DiagramProperties = {
  displayOptions?: DisplayOptions;
  grid?: Grid;
  links?: Links;
  node?: Node;
};
export type Diagram = {
  inspector?: Inspector;
  linkDataArray?: LinkData[];
  modelData?: ModelData;
  nodeDataArray?: NodeData[];
  properties?: DiagramProperties;
};
export type NewDiagram = {
  code?: string;
  comment?: string;
  description?: string;
  graph?: Diagram;
  name?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  svg?: string;
  uuid?: string;
};
export type DiagramOverview = {
  code?: string;
  comment?: string;
  description?: string;
  name?: string;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type DiagramOverviewRead = {
  code?: string;
  comment?: string;
  description?: string;
  name?: string;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type TrueFalseInheritType = "true" | "false" | "inherit";
export type LetterCaseEnum = "upperCase" | "lowerCase";
export type NamingConfig = {
  generateCode?: TrueFalseInheritType;
  generateTableColumnCode?: TrueFalseInheritType;
  letterCase?: LetterCaseEnum;
};
export type StatusEnum = "draft" | "under" | "review" | "published" | "retired";
export type BasicData = {
  limitations?: string;
  purpose?: string;
  status?: StatusEnum;
  tenant?: string;
  usage?: string;
};
export type ExecuteReadNode = {
  id?: string;
  inputParameter?: string;
  mappingCode?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type Method = "call_mapping" | "run_mapping" | "run_script";
export type ExecuteWriteNode = {
  id?: string;
  inputParameter?: string;
  mappingCode?: string;
  method?: Method;
  name?: string;
  onOffFlag?: boolean;
  script?: string;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type FinishNode = {
  id?: string;
  name?: string;
  script?: string;
  throwEvent?: string;
};
export type Interval = "daily" | "weekly" | "monthly";
export type Start = "interval" | "cron" | "workflow_finish" | "run_script";
export type Weekday =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";
export type InitNode = {
  cron?: string;
  day?: number;
  hour?: number;
  id?: string;
  interval?: Interval;
  minute?: number;
  name?: string;
  otherWorkflowCode?: string;
  script?: string;
  start?: Start;
  throwEvent?: string;
  weekday?: Weekday;
};
export type Link = {
  from?: string;
  g_fromCode?: string;
  g_toCode?: string;
  gfromCode?: string;
  gtoCode?: string;
  to?: string;
};
export type LockResourceNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  resourceName?: string;
  throwEvent?: string;
};
export type ParallelMergeNode = {
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type ParallelStartNode = {
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type SubflowExecuteNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type UnlockResourceNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  resourceName?: string;
  throwEvent?: string;
};
export type WaitForEventNode = {
  eventName?: string;
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type WorkflowGraph = {
  executeReadNodes?: ExecuteReadNode[];
  executeWriteNodes?: ExecuteWriteNode[];
  finishNode?: FinishNode;
  initNode?: InitNode;
  links?: Link[];
  lockResourceNodes?: LockResourceNode[];
  parallelMergeNodes?: ParallelMergeNode[];
  parallelStartNodes?: ParallelStartNode[];
  subflowExecuteNodes?: SubflowExecuteNode[];
  unlockResourceNodes?: UnlockResourceNode[];
  waitForEventNodes?: WaitForEventNode[];
};
export type Folder = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  objectSettings?: ObjectSettings[];
  odcs?: BasicData;
  ownerId?: number;
  ownerName?: string;
  stereotypeCode?: string;
  stereotypeId?: number;
  uuid?: string;
  workflow?: WorkflowGraph;
};
export type FolderOverview = {
  businessDomain?: ReferenceObjectInfo;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  owner?: SystemUser;
  stereotype?: ReferenceObjectInfo;
};
export type FolderOverviewRead = {
  businessDomain?: ReferenceObjectInfoRead;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  owner?: SystemUser;
  stereotype?: ReferenceObjectInfoRead;
};
export type MappingColumn = {
  columnCode?: string;
  customAttributes?: CustomAttribute[];
  dataType?: string;
  defaultValue?: string;
  g_code?: string;
  g_mandatory?: boolean;
  gcode?: string;
  gmandatory?: boolean;
  groupByFlag?: boolean;
  id?: number;
  keyFlag?: boolean;
  mapping?: string;
  mappingComment?: string;
  mappingDescription?: string;
  notNull?: boolean;
  order?: number;
  outerMapping?: string;
  stereotypeColumnCode?: string;
  updateFlag?: boolean;
  uuid?: string;
};
export type DefaultMappingType = "none" | "history" | "interface" | "reference";
export type MappingPermissionEnum = "EXECUTE" | "DEBUG";
export type MappingPermission = {
  id?: number;
  order?: number;
  permissions?: MappingPermissionEnum[];
  user?: SystemUser;
};
export type ObjectType = "TABLE" | "VIEW" | "SUB_SELECT" | "DUMMY";
export type Stereotype =
  | "from"
  | "join"
  | "left join"
  | "left outer join"
  | "right join"
  | "right outer join"
  | "full outer join"
  | "cross join"
  | "union"
  | "union all";
export type SourceItem = {
  alias?: string;
  comment?: string;
  description?: string;
  expression?: string;
  g_table?: Table;
  gtable?: Table;
  id?: number;
  objectCode?: string;
  objectCustom?: string;
  objectId?: number;
  objectType?: ObjectType;
  objectUuid?: string;
  order?: number;
  owner?: string;
  ownerId?: number;
  ownerName?: string;
  sourceContext?: string;
  stereotype?: Stereotype;
  uuid?: string;
};
export type Mapping = {
  code?: string;
  columns?: MappingColumn[];
  columnsLastId?: number;
  comment?: string;
  criteria?: string;
  criteriaDescription?: string;
  customAttributes?: CustomAttribute[];
  defaultMappingType?: DefaultMappingType;
  description?: string;
  distinct?: boolean;
  g_key_columns?: MappingColumn[];
  g_templateStereotype?: string;
  g_templateVersion?: number;
  g_update_columns?: MappingColumn[];
  gkeyColumns?: MappingColumn[];
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  gupdateColumns?: MappingColumn[];
  mappingContextScript?: string;
  mappingContextScriptDescription?: string;
  mappingDeleteContextScript?: string;
  mappingDeleteContextScriptDescription?: string;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: MappingPermission[];
  objectSettings?: ObjectSettings[];
  outWhere?: string;
  outWhereDescription?: string;
  ownerId?: number;
  ownerName?: string;
  postMappingScript?: string;
  postMappingScriptDescription?: string;
  preMappingScript?: string;
  preMappingScriptDescription?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  sourceHints?: string;
  sourceHintsDescription?: string;
  sourceItems?: SourceItem[];
  sourceItemsLastId?: number;
  sources?: string;
  sourcesDescription?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  targetCriteria?: string;
  targetCriteriaDescription?: string;
  targetHints?: string;
  targetHintsDescription?: string;
  truncate?: boolean;
  uuid?: string;
};
export type ScriptDto = {
  description?: string;
  script?: string;
};
export type MappingOtherScriptsDto = {
  context?: ScriptDto;
  deleteContext?: ScriptDto;
  outWhere?: ScriptDto;
  postMapping?: ScriptDto;
  preMapping?: ScriptDto;
  sourceHints?: ScriptDto;
  targetHints?: ScriptDto;
};
export type MappingOverview = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  distinct?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
  truncate?: boolean;
};
export type MappingOverviewRead = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  distinct?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
  truncate?: boolean;
};
export type MappingSourcesData = {
  criteria?: ScriptDto;
  sources?: ScriptDto;
  targetCriteria?: ScriptDto;
};
export type BranchRebaseConflictDto = {
  code?: string;
  conflicts?: DiffChangeDto[];
  name?: string;
  structureId?: number;
};
export type BranchRebaseResultDto = {
  blockingMergeRequests?: BranchRebaseBlockingMergeRequestDto[];
  branch?: BranchDto;
  conflicts?: BranchRebaseConflictDto[];
  message?: string;
  status?: Status;
};
export type BranchRebaseResultDtoRead = {
  blockingMergeRequests?: BranchRebaseBlockingMergeRequestDto[];
  branch?: BranchDtoRead;
  conflicts?: BranchRebaseConflictDto[];
  message?: string;
  status?: Status;
};
export type BranchRebaseFieldResolutions = {
  [key: string]: any;
};
export type BranchRebaseConflictResolutions = {
  [key: string]: BranchRebaseFieldResolutions;
};
export type BranchRebaseRequestDto = {
  /** Selected conflict values grouped by structure ID (JSON object keys are numeric IDs as strings). For each structure, use the exact fieldPath returned in conflicts as the key, including the '$' prefix and any collection identity selectors. The value is the selected native JSON value, not a JSON-encoded string: it may be a string, number, boolean, object, array or null. For example, send 42 rather than "42" for a numeric value. oldValue is the current parent value, newValue is the branch value, and baseValue is the original fork-point value; a custom value may also be supplied. Omitting a field leaves its conflict unresolved; explicitly supplying null selects a null value. All current conflicts must be resolved to complete the rebase. Unknown structure IDs or field paths are rejected. */
  conflictResolutions?: BranchRebaseConflictResolutions;
};
export type StructureReferenceDto = {
  code?: string;
  id?: number;
  type?: StructureType;
  uuid?: string;
};
export type Permission = "VIEW" | "EDIT" | "MANAGE_ACCESS" | "FORCE_UNLOCK";
export type StructureMetadataDto = {
  code?: string;
  fullPath?: string;
  id?: number;
  lastModifiedBy?: UserInfoDto;
  lastModifiedTime?: string;
  lockedFor?: UserInfoDto;
  lockedTime?: string;
  name?: string;
  orderPriority?: number;
  parent?: StructureReferenceDto;
  permissions?: Permission[];
  status?: string;
  type?: StructureType;
  uuid?: string;
};
export type StructureMetadataDtoRead = {
  code?: string;
  fullPath?: string;
  id?: number;
  lastModifiedBy?: UserInfoDtoRead;
  lastModifiedTime?: string;
  lockedFor?: UserInfoDtoRead;
  lockedTime?: string;
  name?: string;
  orderPriority?: number;
  parent?: StructureReferenceDto;
  permissions?: Permission[];
  status?: string;
  type?: StructureType;
  uuid?: string;
};
export type SortBy = "DEFAULT" | "NAME" | "TYPE" | "CHANGED";
export type CompletedPhase = {
  phase?: string;
  phaseDetail?: string;
};
export type ProgressDto = {
  completedPhases?: CompletedPhase[];
  done?: number;
  phase?: string;
  phaseDetail?: string;
  phases?: string[];
  progress?: number;
  total?: number;
};
export type AsyncTaskState =
  | "NEW"
  | "RUNNING"
  | "ERROR"
  | "FINISHED"
  | "CANCELLED";
export type AsyncTaskType =
  | "MASS_EXPORT"
  | "UPDATE_TECHNICAL_COLUMNS"
  | "UPDATE_NAMING"
  | "IMPORT_STRUCTURES"
  | "PREVIEW"
  | "DP_GENERATE"
  | "DP_PUSH_TO_GIT"
  | "DP_DEPLOYMENT";
export type AsyncTaskExecutionDto = {
  createdAt?: string;
  createdBy?: string;
  errorMessage?: string;
  id?: number;
  itemDone?: number;
  itemTotal?: number;
  /** Progress in % */
  progress?: number;
  progressDetail?: ProgressDto;
  state?: AsyncTaskState;
  type?: AsyncTaskType;
  updatedAt?: string;
};
export type MassExportSorting =
  | "DEFAULT"
  | "SORT_BY_NAME_ASC"
  | "SORT_BY_TYPE_AND_NAME_ASC";
export type MassExportStrategy =
  | "ZIP_PER_STRUCTURE"
  | "ZIP_OWNER_FOLDER_PER_OBJECT_TYPE"
  | "ZIP_PER_OWNER_AND_OBJECT_TYPE"
  | "SINGLE_FILE";
export type StructureTypeObjTypes = {
  [key: string]: string[];
};
export type MassExportExternalConfigDto = {
  /** Optional if empty >> PREVIEW */
  environmentCode?: string;
  ignoreErrors?: boolean;
  massExportSorting?: MassExportSorting;
  massExportStrategy?: MassExportStrategy;
  structureIds?: number[];
  structureObjectPairs?: StructureTypeObjTypes;
  /** Optional */
  structureStatus?: Status[];
  /** Timestamp of the structure version to be exported. */
  structureTimestamp?: string;
  /** Timestamp of the template version to be exported. */
  templateTimestamp?: string;
};
export type AutocompleteResultDto = {
  code?: string;
  name?: string;
};
export type BasicStructureTypeEnum =
  | "SYSTEM"
  | "FOLDER"
  | "TABLE"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "DIAGRAM";
export type SqlType =
  | "TABLE_HISTORY"
  | "TABLE_REFERENCE"
  | "TABLE"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "FOLDER";
export type DeploymentDto = {
  authorId: number;
  authorName: string;
  created: string;
  description: string;
  environmentCode?: string;
  environmentFeId: number;
  environmentId: number;
  id: number;
  releaseId?: number;
  sqlType: SqlType;
  structureHistoryId: number;
  structureId: number;
  templateId: number;
  version: number;
};
export type HistoryWithDeploymentDto = {
  authorId: number;
  authorName: string;
  branchId?: number;
  code?: string;
  created: string;
  data: {
    [key: string]: any;
  };
  deploymentDto?: DeploymentDto;
  deployments?: DeploymentDto[];
  description?: string;
  id: number;
  isActual?: boolean;
  name?: string;
  structure: StructureReferenceInfoDto;
  version: number;
  versionNumber?: string;
};
export type PageWrapperHistoryWithDeploymentDto = {
  content?: HistoryWithDeploymentDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type HistoryDto = {
  authorId: number;
  authorName: string;
  branchId?: number;
  created: string;
  description?: string;
  id: number;
  structure: StructureReferenceInfoDto;
  version: number;
  versionNumber?: string;
};
export type PrePushValidationType =
  | "BROKEN_LINK"
  | "BROKEN_FK"
  | "MISSING_REQ_FIELD"
  | "MAPPING_COLUMN_CHANGED"
  | "DELETED_COLUMN"
  | "DELETED_IDX"
  | "DELETED_CONSTRAINT"
  | "SOME_EXPECTED_VALUE_MISSING"
  | "SOME_VALUE_REMOVED"
  | "UNIQUE_UUID";
export type PrePushValidationDto = {
  allowedIgnore?: boolean;
  editableByActualUser?: boolean;
  message?: string;
  path?: string;
  structureId?: number;
  structureType?: StructureType;
  type?: PrePushValidationType;
};
export type RelationColumnDto = {
  code?: string;
  uuid?: string;
};
export type RelationType =
  | "PK_FK_TABLE"
  | "PK_FK_COLUMN"
  | "MAPPING_WRITE"
  | "LINK"
  | "LINK_COLUMN"
  | "CUSTOM_LINK";
export type RelationStatus =
  | "OK"
  | "PK_SIDE_REMOVED"
  | "FK_COL_NOT_SET"
  | "PK_COL_REMOVED"
  | "BROKEN";
export type RelationDto = {
  branchId?: number;
  children?: RelationDto[];
  code?: string;
  description?: string;
  id?: number;
  leftSideColumn?: RelationColumnDto;
  leftSideStructure?: StructureReferenceInfoDto;
  name?: string;
  parentRelationId?: number;
  relationType?: RelationType;
  rightSideColumn?: RelationColumnDto;
  rightSideStructure?: StructureReferenceInfoDto;
  status?: RelationStatus;
};
export type RelationCreateDto = {
  code?: string;
  description?: string;
  name?: string;
  rightSideStructure?: StructureReferenceDto;
};
export type JsonPatch = any;
export type MappingItem = {
  code?: string;
  comment?: string;
  dataType?: string;
  description?: string;
  domainCode?: string;
  domainId?: number;
  id?: number;
  name?: string;
  value?: string;
};
export type Environment = {
  code?: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  gitDefaultBranch?: string;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id?: number;
  name?: string;
  production?: boolean;
  rememberPassword?: boolean;
};
export type System = {
  code?: string;
  constants?: MappingItem[];
  constantsLastId?: number;
  customAttributes?: CustomAttribute[];
  diagram?: Diagram;
  environments?: Environment[];
  environmentsLastId?: number;
  lookups?: MappingItem[];
  lookupsLastId?: number;
  minimumNumberOfApprovers?: number;
  name?: string;
  namingConfig?: NamingConfig;
  ownerId?: number;
  ownerName?: string;
  systemTechnologyId?: number;
  systemUsers?: SystemUser[];
  systemUsersLastId?: number;
  uuid?: string;
  workflowTechnologyId?: number;
};
export type TableOverviewPartitioningStrategyTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type TableOverviewPartitioningStrategyTableRead = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type TableScripts = {
  postTableScript?: string;
  preTableScript?: string;
  script?: string;
};
export type ViewColumn = {
  code?: string;
  comment?: string;
  description?: string;
  id?: number;
  mapping?: string;
  name?: string;
  uuid?: string;
};
export type ViewPermissionEnum =
  | "ALTER"
  | "SELECT"
  | "DELETE"
  | "UPDATE"
  | "INSERT"
  | "REFERENCE";
export type ViewPermission = {
  id?: number;
  order?: number;
  permissions?: ViewPermissionEnum[];
  user?: SystemUser;
};
export type View = {
  code?: string;
  columns?: ViewColumn[];
  columnsLastId?: number;
  comment?: string;
  criteriaDescription?: string;
  criteriaScript?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  g_templateVersion?: number;
  gtemplateVersion?: number;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: ViewPermission[];
  objectSettings?: ObjectSettings[];
  ownerId?: number;
  ownerName?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  sourceDescription?: string;
  sourceItems?: SourceItem[];
  sourceItemsLastId?: number;
  sourceScript?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  uuid?: string;
};
export type ViewOverview = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type ViewOverviewRead = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type ViewSourcesData = {
  criteria?: ScriptDto;
  source?: ScriptDto;
};
export type MergeRequestScopeEnum = "FULL" | "PARTIAL";
export type MergeRequestStaleReasonEnum =
  | "SOURCE_BRANCH_CHANGED"
  | "TARGET_BRANCH_CHANGED"
  | "DIFF_RECALCULATED"
  | "MANUAL";
export type MergeRequestDto = {
  approvalCount?: number;
  author?: UserInfoDto;
  changes?: BranchStructureChangeDto[];
  closedAt?: string;
  closedBy?: UserInfoDto;
  decisionAt?: string;
  decisionComment?: string;
  description?: string;
  diffSummary?: string;
  lastReviewer?: UserInfoDto;
  mergeConflictSummary?: string;
  mergeExecutor?: UserInfoDto;
  mergedAt?: string;
  requiredApprovals?: number;
  scope?: MergeRequestScopeEnum;
  selectedStructureIds?: string;
  selfApprovalAllowed?: boolean;
  sourceBranchId?: number;
  staleReason?: MergeRequestStaleReasonEnum;
  status?: MergeRequestStatusEnum;
  targetBranchId?: number;
  title?: string;
};
export type MergeRequestDtoRead = {
  approvalCount?: number;
  author?: UserInfoDtoRead;
  changes?: BranchStructureChangeDto[];
  closedAt?: string;
  closedBy?: UserInfoDtoRead;
  createdAt?: string;
  createdBy?: string;
  decisionAt?: string;
  decisionComment?: string;
  description?: string;
  diffSummary?: string;
  id?: number;
  lastReviewer?: UserInfoDtoRead;
  mergeConflictSummary?: string;
  mergeExecutor?: UserInfoDtoRead;
  mergedAt?: string;
  requiredApprovals?: number;
  scope?: MergeRequestScopeEnum;
  selectedStructureIds?: string;
  selfApprovalAllowed?: boolean;
  sourceBranchId?: number;
  staleReason?: MergeRequestStaleReasonEnum;
  status?: MergeRequestStatusEnum;
  targetBranchId?: number;
  title?: string;
  updatedAt?: string;
  updatedBy?: string;
};
export type MergeEventDto = {
  executedAt?: string;
  executedByUser?: UserInfoDto;
  includedObjects?: string;
  mergeRequestId?: number;
  mergeSummary?: string;
  scope?: string;
  sourceBranchId?: number;
  targetBranchId?: number;
};
export type MergeEventDtoRead = {
  executedAt?: string;
  executedByUser?: UserInfoDtoRead;
  id?: number;
  includedObjects?: string;
  mergeRequestId?: number;
  mergeSummary?: string;
  scope?: string;
  sourceBranchId?: number;
  targetBranchId?: number;
};
export type ReleaseEnvironmentDto = {
  code?: string;
  id?: number;
  name?: string;
  releaseDate?: string;
  released?: boolean;
  releasedTime?: string;
};
export type ObjectSettingsDto = {
  code: string;
  comment?: string;
  defaultFlag?: boolean;
  description?: string;
  name: string;
  structureType?: StructureType;
};
export type ObjectSettingsDtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  defaultFlag?: boolean;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  structureType?: StructureType;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DeploymentInfo = {
  deployedHistoryId?: number;
  deployedVersion?: number;
  id?: string;
  objectTypeCode?: string;
  pushedHistoryId?: number;
  pushedVersion?: number;
};
export type EnvInfo = {
  deploymentInfo?: DeploymentInfo[];
  envCode?: string;
  frontendId?: number;
};
export type StructureReleaseInfoDto = {
  code?: string;
  deleted?: boolean;
  environmentInfo?: EnvInfo[];
  fullPath?: string;
  name?: string;
  parentStructureId?: number;
  permissions?: Permission[];
  structureHistoryId?: number;
  structureId?: number;
  type?: StructureType;
  upToDateWithBranch?: boolean;
};
export type PageWrapperStructureReleaseInfoDto = {
  content?: StructureReleaseInfoDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ExpectationDto = {
  active?: boolean;
  allowedDataTypes?: DataTypeEnum[];
  code?: string;
  description?: string;
  expectationType?: string;
  groupCode?: ExpectationGroupCode;
  id?: number;
  name?: string;
  providerCode?: string;
  providerId?: number;
};
export type CsvImportExistingDomainDto = {
  code?: string;
  customFlag?: boolean;
  dataType?: string;
  defaultValue?: string;
  domainName?: string;
  id?: number;
  notNullFlag?: boolean;
};
export type CsvImportDomainDto = {
  dataType?: string;
  defaultValue?: string;
  domainName?: string;
  mandatoryFlag?: boolean;
  matchedDomain?: CsvImportExistingDomainDto;
  similarDomain?: CsvImportExistingDomainDto[];
};
export type ImportReturnMessageTypeEnum =
  | "INCOMPATIBLE_TARGET"
  | "DOMAIN_NOT_FOUND"
  | "STEREOTYPE_NOT_FOUND"
  | "TABLE_STEREOTYPE_NOT_FOUND"
  | "TABLE_ALREADY_EXISTS_IN_FOLDER"
  | "TABLE_ALREADY_EXISTS_IN_SYSTEM"
  | "INCONSISTENT_TABLES"
  | "INCONSISTENT_DOMAINS"
  | "COLUMN_WITH_SAME_NAME_ALREADY_EXISTS"
  | "COLUMN_WITH_SAME_CODE_ALREADY_EXISTS"
  | "DUPLICATE_COLUMN_NAME"
  | "DUPLICATE_COLUMN_CODE";
export type ImportReturnMessage = {
  messageType?: ImportReturnMessageTypeEnum;
  object?: string;
};
export type CsvImportColumnDto = {
  code?: string;
  comment?: string;
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domainCode?: string;
  domainId?: number;
  indexName?: string;
  name?: string;
  notNullFlag?: boolean;
  primaryKeyName?: string;
  stereoTypeId?: number;
  stereotypeCode?: string;
};
export type CsvImportTableDto = {
  code?: string;
  columnDtoList?: CsvImportColumnDto[];
  comment?: string;
  description?: string;
  name: string;
  postScript?: string;
  preScript?: string;
  script?: string;
  stereotypeCode?: string;
  stereotypeId?: number;
};
export type TechnicalColumnStereotypeDto = {
  code: string;
  columnStereotypeCode: string;
  columnStereotypeId: number;
  columnStereotypeName: string;
  comment?: string;
  dataType: string;
  defaultValue: string;
  description?: string;
  domainCode: string;
  domainId: number;
  domainName: string;
  id: number;
  name: string;
  notNull: boolean;
  ordering: number;
  virtualColumnScript?: string;
};
export type CsvImportReturnDto = {
  domainDtoList?: CsvImportDomainDto[];
  errors?: ImportReturnMessage[];
  tableDtos?: CsvImportTableDto[];
  technicalColumnMap?: {
    [key: string]: TechnicalColumnStereotypeDto[];
  };
  warnings?: ImportReturnMessage[];
};
export type NameNormalisationEnum =
  | "NONE"
  | "UPPERCASE_FIRST_CHARS"
  | "UPPERCASE_ALL";
export type ImportColumn = {
  code?: string;
  comment?: string;
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domainName?: string;
  indexName?: string;
  mandatoryFlag?: boolean;
  name: string;
  order?: number;
  primaryKeyName?: string;
  stereotypeCode?: string;
};
export type ImportTable = {
  code?: string;
  comment?: string;
  description?: string;
  name: string;
  postScript?: string;
  preScript?: string;
  script?: string;
  stereotypeCode?: string;
};
export type CsvImportRowDto = {
  column: ImportColumn;
  table: ImportTable;
};
export type ExistingElementsEnum = "OVERWRITE" | "MERGE";
export type FkMissingTable = "IGNORE" | "IMPORT";
export type FkMoreTables = "IGNORE" | "IMPORT_EXITING" | "IMPORT_IMPORTED";
export type StructureExportDto = {
  actualData?: string;
  children?: StructureExportDto[];
  code?: string;
  name?: string;
  type?: StructureType;
};
export type ReturnMessageTypeEnum =
  | "INCOMPATIBLE_TARGET"
  | "CUSTOM_ATTRIBUTE_NOT_FOUND"
  | "OBJECT_SETTING_NOT_FOUND"
  | "OWNER_NOT_FOUND"
  | "BUSINESS_DOMAIN_NOT_FOUND"
  | "RESPONSIBLE_ANALYST_NOT_FOUND"
  | "RESPONSIBLE_PERSON_NOT_FOUND"
  | "DOMAIN_NOT_FOUND"
  | "STEREOTYPE_NOT_FOUND"
  | "TABLE_ALREADY_EXISTS"
  | "INCONSISTENT_TABLES"
  | "INCONSISTENT_DOMAINS"
  | "COLUMN_WITH_SAME_NAME_ALREADY_EXISTS"
  | "COLUMN_WITH_SAME_CODE_ALREADY_EXISTS"
  | "DUPLICATE_COLUMN_NAME"
  | "DUPLICATE_COLUMN_CODE"
  | "TECHNICAL_COLUMN_COLLISION"
  | "SYSTEM_USER_NOT_FOUND";
export type ReturnMessage = {
  detail?: string;
  messageType?: ReturnMessageTypeEnum;
  object?: string;
};
export type CheckResult = {
  errors?: ReturnMessage[];
  warnings?: ReturnMessage[];
};
export type JsonStructureData = {
  name?: string;
  uuid?: string;
};
export type Id = {
  code?: string;
  id?: number;
  name?: string;
  originalId?: number;
  originalUuid?: string;
  type?: StructureType;
  uuid?: string;
};
export type Structure = {
  data?: JsonStructureData;
  id?: Id;
  locked?: boolean;
  parentId?: Id;
  type?: StructureType;
};
export type AcronymDto = {
  acronym: string;
  text: string;
};
export type AcronymDtoRead = {
  acronym: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  id?: number;
  text: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperAcronymDto = {
  content?: AcronymDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperAcronymDtoRead = {
  content?: AcronymDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type Direction = "ASC" | "DESC";
export type BusinessDomainDto = {
  description?: string;
  name: string;
};
export type BusinessDomainDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperBusinessDomainDto = {
  content?: BusinessDomainDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperBusinessDomainDtoRead = {
  content?: BusinessDomainDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type CustomAttributeGroupDto = {
  code?: string;
  name?: string;
  ordering?: number;
};
export type CustomAttributeGroupDtoRead = {
  code?: string;
  id?: number;
  name?: string;
  ordering?: number;
};
export type PageWrapperCustomAttributeGroupDto = {
  content?: CustomAttributeGroupDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomAttributeGroupDtoRead = {
  content?: CustomAttributeGroupDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type CustomLovValueComboDto = {
  label?: string;
  ordering?: number;
  value?: string;
};
export type CustomLovDto = {
  description?: string;
  lovValues?: CustomLovValueComboDto[];
  name: string;
};
export type CustomLovDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperCustomLovDto = {
  content?: CustomLovDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomLovDtoRead = {
  content?: CustomLovDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type CustomAttributeStructureTypeEnum =
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "TABLE_COLUMN"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE";
export type CustomAttributeTypeEnum =
  | "STRING"
  | "SCRIPT"
  | "NUMBER"
  | "BOOLEAN"
  | "LOV"
  | "ARRAY";
export type CustomAttributeDto = {
  customLovId?: number;
  description?: string;
  group?: LovReference;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
};
export type CustomAttributeDtoRead = {
  createdAt?: string;
  createdBy?: string;
  customLovId?: number;
  deleted?: boolean;
  description?: string;
  group?: LovReferenceRead;
  id?: number;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperCustomAttributeDto = {
  content?: CustomAttributeDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomAttributeDtoRead = {
  content?: CustomAttributeDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type DomainTechnologyV2Dto = {
  dataType: string;
  defaultValue?: string;
  technology: LovReference;
};
export type DomainTechnologyV2DtoRead = {
  dataType: string;
  defaultValue?: string;
  id: number;
  technology: LovReferenceRead;
};
export type DomainV2Dto = {
  code: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyV2Dto[];
  hasTemplate: boolean;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type DomainV2DtoRead = {
  code: string;
  createdAt?: string;
  createdBy?: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  deleted?: boolean;
  description?: string;
  domainTechnologies?: DomainTechnologyV2DtoRead[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperDomainV2Dto = {
  content?: DomainV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperDomainV2DtoRead = {
  content?: DomainV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ImpactChangeCodeListDto = {
  affectedElements?: {
    [key: string]: number;
  };
};
export type DomainTechnologyDto = {
  dataType: string;
  defaultValue?: string;
  id: number;
  technologyCode: string;
  technologyId?: number;
};
export type DomainUpdateDto = {
  code: string;
  companyName: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type PageWrapperObjectSettingsDto = {
  content?: ObjectSettingsDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperObjectSettingsDtoRead = {
  content?: ObjectSettingsDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type StereotypeCategory = "BEHAVIORAL" | "DEFAULT" | "USER_DEFINED";
export type StereotypeType =
  | "FOLDER"
  | "TABLE"
  | "TABLE_INTERFACE"
  | "TABLE_HISTORY"
  | "COLUMN"
  | "MAPPING"
  | "MAPPING_TYPE"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "CONSTANT_DOMAIN"
  | "VIEW"
  | "WORKFLOW"
  | "API_NODE"
  | "API_NODE_ATTRIBUTE"
  | "API_ROWSET"
  | "QUEUE"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type StereotypeV2Dto = {
  category: StereotypeCategory;
  code: string;
  description?: string;
  name: string;
  type: StereotypeType;
};
export type StereotypeV2DtoRead = {
  category: StereotypeCategory;
  code: string;
  description?: string;
  id: number;
  internal?: boolean;
  name: string;
  type: StereotypeType;
};
export type PageWrapperStereotypeV2Dto = {
  content?: StereotypeV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperStereotypeV2DtoRead = {
  content?: StereotypeV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TechnicalColumnV2Dto = {
  code: string;
  comment?: string;
  description?: string;
  domain: LovReference;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumn?: LovReference;
  stereotypes?: LovReference[];
  virtualColumnScript?: string;
};
export type TechnicalColumnV2DtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  domain: LovReferenceRead;
  id?: number;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumn?: LovReferenceRead;
  stereotypes?: LovReferenceRead[];
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
  virtualColumnScript?: string;
};
export type PageWrapperTechnicalColumnV2Dto = {
  content?: TechnicalColumnV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperTechnicalColumnV2DtoRead = {
  content?: TechnicalColumnV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TechnologyType = "SYSTEM" | "WORKFLOW";
export type TechnologyV2Dto = {
  code: string;
  description: string;
  name: string;
  type: TechnologyType;
};
export type TechnologyV2DtoRead = {
  code: string;
  description: string;
  id: number;
  name: string;
  type: TechnologyType;
};
export type PageWrapperTechnologyV2Dto = {
  content?: TechnologyV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperTechnologyV2DtoRead = {
  content?: TechnologyV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type MergeRequestDecisionEnum = "APPROVE" | "REQUEST_CHANGES" | "REJECT";
export type MergeRequestApprovalDto = {
  comment?: string;
  decidedAt?: string;
  decision?: MergeRequestDecisionEnum;
  mergeRequestId?: number;
  user?: UserInfoDto;
};
export type MergeRequestApprovalDtoRead = {
  active?: boolean;
  comment?: string;
  decidedAt?: string;
  decision?: MergeRequestDecisionEnum;
  id?: number;
  mergeRequestId?: number;
  user?: UserInfoDtoRead;
};
export type MergeRequestConflictResolutionDto = {
  fieldPath?: string;
  mergeRequestId?: number;
  resolution?: string;
  resolvedAt?: string;
  resolvedByUser?: UserInfoDto;
  selectedValue?: string;
  sourceValue?: string;
  structureId?: string;
  targetValue?: string;
};
export type MergeRequestConflictResolutionDtoRead = {
  fieldPath?: string;
  id?: number;
  mergeRequestId?: number;
  resolution?: string;
  resolvedAt?: string;
  resolvedByUser?: UserInfoDtoRead;
  selectedValue?: string;
  sourceValue?: string;
  structureId?: string;
  targetValue?: string;
};
export type SecretType = "GIT_TOKEN";
export type SecretDto = {
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  type?: SecretType;
  validTo?: string;
};
export type SecretDtoRead = {
  description?: string;
  id?: number;
  name?: string;
  owner?: UserInfoDtoRead;
  type?: SecretType;
  validTo?: string;
};
export type SecretDtoWrite = {
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  type?: SecretType;
  validTo?: string;
  value?: string;
};
export type StructureDto = {
  authorId?: number;
  authorName?: string;
  canEdit: boolean;
  code: string;
  companyId: number;
  description?: string;
  fullPath?: string;
  hasChildren: boolean;
  id: number;
  lockTime?: string;
  lockUserId?: number;
  lockUserName?: string;
  name: string;
  orderPriority?: number;
  parentStructureId?: number;
  status?: string;
  type: StructureType;
  uuid?: string;
};
export type AclEntryDto = {
  allowedPermissions?: Permission[];
  deniedPermissions?: Permission[];
  groupName?: string;
};
export type AclEntryDtoRead = {
  allowedPermissions?: Permission[];
  deniedPermissions?: Permission[];
  groupName?: string;
  id?: number;
};
export type PermissionSourceDto = {
  aclEntryId?: number;
  groupName?: string;
  structure?: StructureMetadataDto;
};
export type PermissionSourceDtoRead = {
  aclEntryId?: number;
  groupName?: string;
  structure?: StructureMetadataDtoRead;
};
export type PermissionEvaluationItemDto = {
  allowedFrom?: PermissionSourceDto[];
  deniedFrom?: PermissionSourceDto[];
  granted?: boolean;
  permission?: Permission;
};
export type PermissionEvaluationItemDtoRead = {
  allowedFrom?: PermissionSourceDtoRead[];
  deniedFrom?: PermissionSourceDtoRead[];
  granted?: boolean;
  permission?: Permission;
};
export type PermissionEvaluationDto = {
  permissions?: PermissionEvaluationItemDto[];
  structure?: StructureMetadataDto;
};
export type PermissionEvaluationDtoRead = {
  permissions?: PermissionEvaluationItemDtoRead[];
  structure?: StructureMetadataDtoRead;
};
export type PageWrapperBranchDto = {
  content?: BranchDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperBranchDtoRead = {
  content?: BranchDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperReleaseDto = {
  content?: ReleaseDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperReleaseDtoRead = {
  content?: ReleaseDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperMergeRequestDto = {
  content?: MergeRequestDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperMergeRequestDtoRead = {
  content?: MergeRequestDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TableOverviewPartitioningStrategyHistoryTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type TableOverviewPartitioningStrategyHistoryTableRead = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type FormatType = "PYTHON" | "SQL" | "PLAIN_TEXT";
export type TemplateListDto = {
  author?: UserInfoDto;
  comment?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateListDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type TemplateDto = {
  author?: UserInfoDto;
  comment?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type TenantDto = {
  information?: string;
};
export type TenantDtoRead = {
  id?: number;
  information?: string;
  name?: string;
};
export type UserType = "STANDARD" | "ADMIN" | "READER" | "API";
export type UserDto = {
  department?: string;
  description?: string;
  email: string;
  loginName: string;
  name: string;
  surname: string;
  type?: UserType;
};
export type UserDtoRead = {
  canBeEdited?: boolean;
  companyName?: string;
  compositeName?: string;
  deleted?: boolean;
  department?: string;
  description?: string;
  email: string;
  hardLock?: boolean;
  id?: number;
  loginName: string;
  name: string;
  support?: boolean;
  surname: string;
  type?: UserType;
};
export type PageWrapperUserDto = {
  content?: UserDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperUserDtoRead = {
  content?: UserDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ApiUserDto = {
  clientId?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  writeAccess?: boolean;
};
export type ApiUserDtoRead = {
  clientId?: string;
  clientSecret?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDtoRead;
  writeAccess?: boolean;
};
export type SessionContextDto = {
  context?: string;
  user?: UserDto;
};
export type SessionContextDtoRead = {
  context?: string;
  user?: UserDtoRead;
};
export type GroupDto = {
  description?: string;
  name?: string;
};
export type GroupDtoRead = {
  description?: string;
  id?: string;
  name?: string;
};
export type RoleEnum =
  | "SUPER_ADMIN"
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "EXT_SYSTEM"
  | "EXT_SYSTEM_WRITE"
  | "ADMIN"
  | "READER"
  | "SUPPORT"
  | "MANAGE_TEMPLATES"
  | "MANAGE_CREDENTIALS";
export type ManagedRole =
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "MANAGE_TEMPLATES"
  | "MANAGE_CREDENTIALS";
export type UserComboDto = {
  id: number;
  value: string;
};
export const {
  useGetProvidersAdminQuery,
  useLazyGetProvidersAdminQuery,
  useCreateProviderAdminMutation,
  useDeleteProviderAdminMutation,
  useGetProviderAdminQuery,
  useLazyGetProviderAdminQuery,
  useUpdateProviderAdminMutation,
  useGetExpectationsAdminQuery,
  useLazyGetExpectationsAdminQuery,
  useCreateExpectationAdminMutation,
  useDeleteExpectationAdminMutation,
  useGetExpectationAdminQuery,
  useLazyGetExpectationAdminQuery,
  useUpdateExpectationAdminMutation,
  useDeleteBranchMutation,
  useGetBranchQuery,
  useLazyGetBranchQuery,
  useUpdateBranchMutation,
  useActivateBranchMutation,
  useArchiveBranchMutation,
  useGetBranchChangesQuery,
  useLazyGetBranchChangesQuery,
  useCherryPickMutation,
  usePreviewCherryPickMutation,
  useUpdateDeploymentPackageMutation,
  useGetDataForDiagramQuery,
  useLazyGetDataForDiagramQuery,
  useGetDiagramByIdQuery,
  useLazyGetDiagramByIdQuery,
  useUpdateDiagramMutation,
  useGetDiagramDataQuery,
  useLazyGetDiagramDataQuery,
  useUpdateDiagramDataMutation,
  useGetDiagramOverviewQuery,
  useLazyGetDiagramOverviewQuery,
  useUpdateDiagramOverviewMutation,
  useGetDiagramSvgQuery,
  useLazyGetDiagramSvgQuery,
  useUpdateDiagramSvgMutation,
  useGetStructureDetailFolderQuery,
  useLazyGetStructureDetailFolderQuery,
  useUpdateFolderFolderMutation,
  useGetOdcsFolderQuery,
  useLazyGetOdcsFolderQuery,
  useUpdateOdcsFolderMutation,
  useSetOdcsStatusFolderMutation,
  useGetFolderOverviewFolderQuery,
  useLazyGetFolderOverviewFolderQuery,
  useUpdateFolderOverviewFolderMutation,
  useUnlockBranchMutation,
  useLockBranchMutation,
  useGetStructureDetailMappingQuery,
  useLazyGetStructureDetailMappingQuery,
  useUpdateMappingMappingMutation,
  useGetMappingColumnsMappingQuery,
  useLazyGetMappingColumnsMappingQuery,
  useAddMappingColumnMappingMutation,
  useUpdateMappingColumnsMappingMutation,
  useUpdateMappingColumnMapping1Mutation,
  useUpdateMappingColumnMappingMutation,
  useGetMappingOtherScriptsMappingQuery,
  useLazyGetMappingOtherScriptsMappingQuery,
  useUpdateMappingOtherScriptsMappingMutation,
  useGetMappingOverviewMappingQuery,
  useLazyGetMappingOverviewMappingQuery,
  useUpdateMappingOverviewMappingMutation,
  useGetMappingPermissionsMappingQuery,
  useLazyGetMappingPermissionsMappingQuery,
  useSetMappingPermissionMappingMutation,
  useDeleteMappingPermissionMappingMutation,
  useGetMappingSourcesMappingQuery,
  useLazyGetMappingSourcesMappingQuery,
  useAddMappingSourceItemMappingMutation,
  useUpdateMappingSourceItemsMappingMutation,
  useGetMappingSourcesDataMappingQuery,
  useLazyGetMappingSourcesDataMappingQuery,
  useUpdateMappingSourcesDataMappingMutation,
  useDeleteMappingSourceItemMappingMutation,
  useUpdateMappingSourceItemMappingMutation,
  useRebaseBranchMutation,
  useGetStructuresStructureV2Query,
  useLazyGetStructuresStructureV2Query,
  useGenerateScriptsStructureV2Mutation,
  useBulkUnlockStructureV2Mutation,
  useBulkLockStructureV2Mutation,
  useSearchTableColumnsStructureV2Query,
  useLazySearchTableColumnsStructureV2Query,
  useGetFullTreeStructureV2Query,
  useLazyGetFullTreeStructureV2Query,
  useGetChildrenStructureV2Query,
  useLazyGetChildrenStructureV2Query,
  useCreateStructureStructureV2Mutation,
  useDeleteStructureStructureV2Mutation,
  useGetStructureMetadataStructureV2Query,
  useLazyGetStructureMetadataStructureV2Query,
  useAsyncStructurePreviewStructureV2Mutation,
  useGetStructureHistoryStructureV2Query,
  useLazyGetStructureHistoryStructureV2Query,
  useCreateStructureHistoryStructureV2Mutation,
  usePrePushValidationStructureV2Query,
  useLazyPrePushValidationStructureV2Query,
  useCompareStructureHistoryStructureV2Query,
  useLazyCompareStructureHistoryStructureV2Query,
  useGetStructureHistoryWithDeploymentStructureV2Query,
  useLazyGetStructureHistoryWithDeploymentStructureV2Query,
  useReplaceStructureVersionStructureV2Mutation,
  useUnLockStructureStructureV2Mutation,
  useLockStructureStructureV2Mutation,
  useMoveNodeStructureV2Mutation,
  useGetNodeRelationsRelationQuery,
  useLazyGetNodeRelationsRelationQuery,
  useCreateRelationRelationMutation,
  useDeleteRelationRelationMutation,
  usePatchRelationRelationMutation,
  useUpdateRelationRelationMutation,
  useGetParentSystemStructureV2Query,
  useLazyGetParentSystemStructureV2Query,
  useGetStructureTreeStructureV2Query,
  useLazyGetStructureTreeStructureV2Query,
  useSearchNodesWithTypeStructureV2Query,
  useLazySearchNodesWithTypeStructureV2Query,
  useGetStructureDetailTableQuery,
  useLazyGetStructureDetailTableQuery,
  useUpdateTableTableMutation,
  useGetTableColumnsTableQuery,
  useLazyGetTableColumnsTableQuery,
  useAddTableColumnTableMutation,
  useUpdateTableColumnsTableMutation,
  useDeleteTableColumnTableMutation,
  useUpdateTableColumnTableMutation,
  useGetTableConstraintsTableQuery,
  useLazyGetTableConstraintsTableQuery,
  useAddTableConstraintTableMutation,
  useUpdateTableConstraintsTableMutation,
  useDeleteTableConstraintTableMutation,
  useUpdateTableConstraintTableMutation,
  useGetTableIndexesTableQuery,
  useLazyGetTableIndexesTableQuery,
  useAddTableIndexTableMutation,
  useUpdateTableIndexesTableMutation,
  useDeleteTableIndexTableMutation,
  useUpdateTableIndexTableMutation,
  useGetTableOverviewTableQuery,
  useLazyGetTableOverviewTableQuery,
  useUpdateTableOverviewTableMutation,
  useDeleteTablePermissionTableMutation,
  useGetTablePermissionsTableQuery,
  useLazyGetTablePermissionsTableQuery,
  useSetTablePermissionTableMutation,
  useGetTableScriptsTableQuery,
  useLazyGetTableScriptsTableQuery,
  useUpdateTableScriptsTableMutation,
  useGetStructureDetailViewQuery,
  useLazyGetStructureDetailViewQuery,
  useUpdateViewViewMutation,
  useGetViewColumnsViewQuery,
  useLazyGetViewColumnsViewQuery,
  useAddViewColumnViewMutation,
  useUpdateViewColumnsViewMutation,
  useUpdateViewColumnView1Mutation,
  useUpdateViewColumnViewMutation,
  useGetViewOverviewViewQuery,
  useLazyGetViewOverviewViewQuery,
  useUpdateViewOverviewViewMutation,
  useGetViewPermissionsViewQuery,
  useLazyGetViewPermissionsViewQuery,
  useSetViewPermissionViewMutation,
  useDeleteViewPermissionViewMutation,
  useGetViewSourcesViewQuery,
  useLazyGetViewSourcesViewQuery,
  useAddViewSourceItemViewMutation,
  useUpdateViewSourceItemsViewMutation,
  useGetViewSourcesDataViewQuery,
  useLazyGetViewSourcesDataViewQuery,
  useUpdateViewSourcesDataViewMutation,
  useDeleteViewSourceItemViewMutation,
  useUpdateViewSourceItemViewMutation,
  useGetBranchChangesBetweenQuery,
  useLazyGetBranchChangesBetweenQuery,
  useCreateMergeRequestMutation,
  useGetMergeRequestsForBranchPairQuery,
  useLazyGetMergeRequestsForBranchPairQuery,
  useGetEventsForTargetBranchQuery,
  useLazyGetEventsForTargetBranchQuery,
  useGetMergeRequestsForTargetBranchQuery,
  useLazyGetMergeRequestsForTargetBranchQuery,
  useDeleteSystemReleaseMutation,
  useGetSystemReleaseQuery,
  useLazyGetSystemReleaseQuery,
  useUpdateSystemReleaseMutation,
  useGetReleaseEnvironmentsQuery,
  useLazyGetReleaseEnvironmentsQuery,
  useCreateReleaseEnvironmentMutation,
  useDeleteReleaseEnvironmentMutation,
  useUpdateReleaseEnvironmentMutation,
  usePushReleaseToGitMutation,
  useCreateReleaseScriptsMutation,
  useCreateDeploymentsMutation,
  useGetObjectSettingsQuery,
  useLazyGetObjectSettingsQuery,
  useChangeReleaseStatusMutation,
  useGetReleaseStructuresQuery,
  useLazyGetReleaseStructuresQuery,
  useAddStructureToReleaseMutation,
  useDeleteReleaseStructureMutation,
  useGetProvidersQuery,
  useLazyGetProvidersQuery,
  useGetExpectationsQuery,
  useLazyGetExpectationsQuery,
  useImportStructureCsvIntoNodeMutation,
  useImportStructureCsvIntoNodeCheckMutation,
  useImportColumnsFromCsvMutation,
  useImportColumnsFromCsvCheckMutation,
  useImportStructuresMutation,
  useCheckJsonMutation,
  useGetImportResultQuery,
  useLazyGetImportResultQuery,
  useGetAllLovAcronymQuery,
  useLazyGetAllLovAcronymQuery,
  useCreateLovAcronymMutation,
  useDeleteLovAcronymMutation,
  useGetLovAcronymQuery,
  useLazyGetLovAcronymQuery,
  useUpdateLovAcronymMutation,
  useGetAllLovBusinessDomainQuery,
  useLazyGetAllLovBusinessDomainQuery,
  useCreateLovBusinessDomainMutation,
  useDeleteLovBusinessDomainMutation,
  useGetLovBusinessDomainQuery,
  useLazyGetLovBusinessDomainQuery,
  useUpdateLovBusinessDomainMutation,
  useGetAllLovCustomAttributeGroupQuery,
  useLazyGetAllLovCustomAttributeGroupQuery,
  useCreateLovCustomAttributeGroupMutation,
  useDeleteLovCustomAttributeGroupMutation,
  useGetLovCustomAttributeGroupQuery,
  useLazyGetLovCustomAttributeGroupQuery,
  useUpdateLovCustomAttributeGroupMutation,
  useGetAllLovCustomAttributeLovQuery,
  useLazyGetAllLovCustomAttributeLovQuery,
  useCreateLovCustomAttributeLovMutation,
  useDownloadCustomLovsLovCustomAttributeLovQuery,
  useLazyDownloadCustomLovsLovCustomAttributeLovQuery,
  useDeleteLovCustomAttributeLovMutation,
  useGetLovCustomAttributeLovQuery,
  useLazyGetLovCustomAttributeLovQuery,
  useUpdateLovCustomAttributeLovMutation,
  useGetAllLovCustomAttributeQuery,
  useLazyGetAllLovCustomAttributeQuery,
  useCreateLovCustomAttributeMutation,
  useDeleteLovCustomAttributeMutation,
  useGetLovCustomAttributeQuery,
  useLazyGetLovCustomAttributeQuery,
  useUpdateLovCustomAttributeMutation,
  useGetAllLovDomainQuery,
  useLazyGetAllLovDomainQuery,
  useCreateLovDomainMutation,
  useDeleteLovDomainMutation,
  useGetLovDomainQuery,
  useLazyGetLovDomainQuery,
  useUpdateLovDomainMutation,
  useComputeImpactDomainChangeLovDomainMutation,
  useGetAllLovObjectTypeQuery,
  useLazyGetAllLovObjectTypeQuery,
  useCreateLovObjectTypeMutation,
  useDeleteLovObjectTypeMutation,
  useGetLovObjectTypeQuery,
  useLazyGetLovObjectTypeQuery,
  useUpdateLovObjectTypeMutation,
  useGetAllLovStereotypeQuery,
  useLazyGetAllLovStereotypeQuery,
  useCreateLovStereotypeMutation,
  useDeleteLovStereotypeMutation,
  useGetLovStereotypeQuery,
  useLazyGetLovStereotypeQuery,
  useUpdateLovStereotypeMutation,
  useGetAllLovTechnicalColumnQuery,
  useLazyGetAllLovTechnicalColumnQuery,
  useCreateLovTechnicalColumnMutation,
  useDeleteLovTechnicalColumnMutation,
  useGetLovTechnicalColumnQuery,
  useLazyGetLovTechnicalColumnQuery,
  useUpdateLovTechnicalColumnMutation,
  useComputeImpactTcChangeLovTechnicalColumnMutation,
  useGetAllLovTechnologyQuery,
  useLazyGetAllLovTechnologyQuery,
  useGetMergeRequestQuery,
  useLazyGetMergeRequestQuery,
  useGetApprovalsQuery,
  useLazyGetApprovalsQuery,
  useSaveResolutionMutation,
  useGetResolutionsQuery,
  useLazyGetResolutionsQuery,
  useDecideMutation,
  useExecuteMergeMutation,
  useGetEventsForMergeRequestQuery,
  useLazyGetEventsForMergeRequestQuery,
  useRecalculateDiffMutation,
  useMarkStaleMutation,
  useUpdateMergeRequestStatusMutation,
  useGetSecretsQuery,
  useLazyGetSecretsQuery,
  useCreateSecretMutation,
  useDeleteSecretMutation,
  useGetSecretQuery,
  useLazyGetSecretQuery,
  useUpdateSecretMutation,
  useCreateSystemMutation,
  useGetSystemsQuery,
  useLazyGetSystemsQuery,
  useGetDeletedStructuresQuery,
  useLazyGetDeletedStructuresQuery,
  useUndeleteStructureMutation,
  useGetStructureAclQuery,
  useLazyGetStructureAclQuery,
  useCreateStructureAclMutation,
  useGetEffectiveAclQuery,
  useLazyGetEffectiveAclQuery,
  useEvaluatePermissionsQuery,
  useLazyEvaluatePermissionsQuery,
  useDeleteStructureAclMutation,
  useUpdateStructureAclMutation,
  useCountQuery,
  useLazyCountQuery,
  useGetStructureHistoryByIdQuery,
  useLazyGetStructureHistoryByIdQuery,
  useGetBranchesQuery,
  useLazyGetBranchesQuery,
  useCreateBranchMutation,
  useGetDeploymentPackagesQuery,
  useLazyGetDeploymentPackagesQuery,
  useCreateDeploymentPackageMutation,
  useGetEnvGitBranchesQuery,
  useLazyGetEnvGitBranchesQuery,
  useGetMergeRequestsInSystemQuery,
  useLazyGetMergeRequestsInSystemQuery,
  useGetStructureDetailTableHistoryQuery,
  useLazyGetStructureDetailTableHistoryQuery,
  useUpdateTableTableHistoryMutation,
  useGetTableColumnsTableHistoryQuery,
  useLazyGetTableColumnsTableHistoryQuery,
  useGetTableConstraintsTableHistoryQuery,
  useLazyGetTableConstraintsTableHistoryQuery,
  useAddTableConstraintTableHistoryMutation,
  useUpdateTableConstraintsTableHistoryMutation,
  useDeleteTableConstraintTableHistoryMutation,
  useUpdateTableConstraintTableHistoryMutation,
  useGetTableIndexesTableHistoryQuery,
  useLazyGetTableIndexesTableHistoryQuery,
  useAddTableIndexTableHistoryMutation,
  useUpdateTableIndexesTableHistoryMutation,
  useDeleteTableIndexTableHistoryMutation,
  useUpdateTableIndexTableHistoryMutation,
  useGetTableOverviewTableHistoryQuery,
  useLazyGetTableOverviewTableHistoryQuery,
  useUpdateTableOverviewTableHistoryMutation,
  useDeleteTablePermissionTableHistoryMutation,
  useGetTablePermissionsTableHistoryQuery,
  useLazyGetTablePermissionsTableHistoryQuery,
  useSetTablePermissionTableHistoryMutation,
  useGetTableScriptsTableHistoryQuery,
  useLazyGetTableScriptsTableHistoryQuery,
  useUpdateTableScriptsTableHistoryMutation,
  useGetStructureDetailTableReferenceQuery,
  useLazyGetStructureDetailTableReferenceQuery,
  useUpdateTableTableReferenceMutation,
  useGetTableColumnsTableReferenceQuery,
  useLazyGetTableColumnsTableReferenceQuery,
  useGetTableConstraintsTableReferenceQuery,
  useLazyGetTableConstraintsTableReferenceQuery,
  useAddTableConstraintTableReferenceMutation,
  useUpdateTableConstraintsTableReferenceMutation,
  useDeleteTableConstraintTableReferenceMutation,
  useUpdateTableConstraintTableReferenceMutation,
  useGetTableIndexesTableReferenceQuery,
  useLazyGetTableIndexesTableReferenceQuery,
  useAddTableIndexTableReferenceMutation,
  useUpdateTableIndexesTableReferenceMutation,
  useDeleteTableIndexTableReferenceMutation,
  useUpdateTableIndexTableReferenceMutation,
  useGetTableOverviewTableReferenceQuery,
  useLazyGetTableOverviewTableReferenceQuery,
  useUpdateTableOverviewTableReferenceMutation,
  useDeleteTablePermissionTableReferenceMutation,
  useGetTablePermissionsTableReferenceQuery,
  useLazyGetTablePermissionsTableReferenceQuery,
  useSetTablePermissionTableReferenceMutation,
  useGetTableScriptsTableReferenceQuery,
  useLazyGetTableScriptsTableReferenceQuery,
  useUpdateTableScriptsTableReferenceMutation,
  useGetAllTemplatesQuery,
  useLazyGetAllTemplatesQuery,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useUpdateTemplateMutation,
  useGetTemplateHistoryQuery,
  useLazyGetTemplateHistoryQuery,
  useGetTemplateHistoryDetailQuery,
  useLazyGetTemplateHistoryDetailQuery,
  usePostTemplateLockMutation,
  usePostTemplatePushMutation,
  usePostTemplateUnlockMutation,
  useGetTenantQuery,
  useLazyGetTenantQuery,
  useUpdateTenantMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useAddUserMutation,
  useGetApiUsersQuery,
  useLazyGetApiUsersQuery,
  useAddApiUserMutation,
  useDeleteApiUserMutation,
  useApiUserUpdateMutation,
  useApiUserResetSecretMutation,
  useGetSessionContextQuery,
  useLazyGetSessionContextQuery,
  useUpdateSessionContextMutation,
  useGetGroupsQuery,
  useLazyGetGroupsQuery,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useUpdateGroupMutation,
  useGetRolesForGroupQuery,
  useLazyGetRolesForGroupQuery,
  useSetRolesForGroupMutation,
  useRemoveUserFromGroupMutation,
  useGetUsersInGroupQuery,
  useLazyGetUsersInGroupQuery,
  useAddUserToGroupMutation,
  useGetUserListQuery,
  useLazyGetUserListQuery,
  useDeleteUserMutation,
  useGetUserQuery,
  useLazyGetUserQuery,
  useEditUserMutation,
  useGetUserGroupsQuery,
  useLazyGetUserGroupsQuery,
  useUnLockUserMutation,
  useLockUserMutation,
  useResetPasswordMutation,
  useGetRolesForUserQuery,
  useLazyGetRolesForUserQuery,
  useSetRolesForUserMutation,
} = injectedRtkApi;
